export const translations = {
  it: {
    meta: {
      title: "Gestionali su misura e agenti AI in Svizzera — XS Consulting",
      description: "XS Consulting costruisce team di dipendenti AI, gestionali su misura e progettazione impianti per aziende in Svizzera e nel mondo. Scrivici su WhatsApp.",
    },
    common: {
      waDefault: "Ciao XS Consulting! Vorrei maggiori informazioni.",
      welcome: "Bentornato su XS Consulting. Se vuoi, ti guido io: apri l'assistente in basso a destra e ti faccio vedere cosa possiamo costruire per la tua azienda.",
      welcomeCta: "Ascolta il benvenuto vocale",
    },
    nav: {
      links: [
        { href: "#servizi", id: "servizi", label: "Servizi" },
        { href: "#agenti", id: "agenti", label: "Agenti AI" },
        { href: "#progetti", id: "progetti", label: "Progetti" },
        { href: "#academy", id: "academy", label: "Academy" },
        { href: "#metodo", id: "metodo", label: "Metodo" },
        { href: "/blog", id: "blog", label: "Blog" },
      ],
      whatsapp: "WhatsApp",
      demo: "Prenota demo",
    },
    hero: {
      overline: "Progettiamo il tuo futuro d'impresa",
      h1Plain: "Agenti AI e gestionali su misura per PMI in Svizzera",
      h1a: ["Agenti", "AI", "e"],
      h1neon: ["gestionali", "su", "misura"],
      h1b: ["per", "PMI", "in", "Svizzera"],
      subtitle:
        "Costruiamo il primo team di dipendenti AI per la tua azienda. I nostri agenti AI lavorano insieme al tuo team, automatizzano i processi e collaborano tra loro 24 ore su 24. Soluzioni su misura, non pacchetti standard.",
      whatsapp: "Scrivici su WhatsApp",
      whatsappMessage: "Ciao XS Consulting! Vorrei maggiori informazioni sul vostro team di agenti AI.",
      demo: "Prenota una demo gratuita",
      claim: "Oltre 50 aziende hanno già trasformato il loro business con noi.",
    },
    marquee: {
      label: "Ci integriamo con gli strumenti che usi ogni giorno",
    },
    cookies: {
      title: "Cookie e privacy",
      text: "Usiamo cookie tecnici e, con il tuo consenso, strumenti di analisi per migliorare il sito.",
      accept: "Accetta",
      reject: "Rifiuta",
    },
    expertise: {
      overline: "Cosa facciamo",
      titleA: "Soluzioni su misura,",
      titleNeon: "non pacchetti standard",
      subtitle:
        "Tre anime, un solo metodo: software gestionale costruito sui tuoi processi, progettazione impianti affidata a professionisti veri e automazione per chi vende sui marketplace. Online, ovunque tu sia.",
      cards: {
        gestionale: {
          chip: "Software",
          title: "Gestionali su misura",
          desc: "Non adattiamo la tua azienda a un software: costruiamo il software attorno alla tua azienda. ERP, CRM e piattaforme operative disegnate sui tuoi processi.",
          bullets: [
            "ERP e CRM costruiti sui tuoi flussi",
            "Automazione di ordini, magazzino e fatturazione",
            "Dashboard direzionale con dati in tempo reale",
            "Integrazione con gli strumenti che già usi",
          ],
        },
        impianti: {
          chip: "Ingegneria",
          title: "Progettazione impianti",
          desc: "Professionisti veri della progettazione impianti: dal rilievo al dimensionamento, fino alla documentazione tecnica esecutiva.",
          bullets: [
            "Rilievo e analisi delle esigenze",
            "Dimensionamento e schemi esecutivi",
            "Documentazione tecnica completa",
            "Coordinamento digitale delle commesse",
          ],
        },
        marketplace: {
          chip: "E-commerce",
          title: "Automazione Marketplace",
          desc: "Vendi su Amazon, eBay o Zalando? Automatizziamo le operazioni ripetitive, così tu ti concentri sulla crescita.",
          bullets: [
            "Catalogo e prezzi sincronizzati su più marketplace",
            "Magazzino allineato in tempo reale",
            "Repricing intelligente e ordini automatici",
            "Assistenza clienti con AI",
          ],
        },
      },
      cta: "Scopri il servizio",
    },
    agents: {
      overline: "I nostri agenti AI",
      titleA: "Un team completo di",
      titleNeon: "agenti AI",
      subtitle:
        "Ogni agente è specializzato. Connessi al cervello centrale, collaborano tra loro 24 ore su 24. Insieme sono imbattibili.",
      list: [
        { id: "sales", name: "Sales Agent", desc: "Analizza clienti, invia email personalizzate, gestisce follow-up e chiude vendite.", tags: ["Ricerca lead", "Email & LinkedIn", "Preventivi automatici"] },
        { id: "marketing", name: "Marketing Agent", desc: "Crea campagne, gestisce contenuti e analizza la performance.", tags: ["Content creation", "Email marketing", "Analisi ROI"] },
        { id: "operations", name: "Operations Agent", desc: "Gestisce processi, task, ticket, documenti e flussi operativi.", tags: ["Gestione task", "Ticketing system", "Reportistica"] },
        { id: "finance", name: "Finance Agent", desc: "Si occupa di fatture, pagamenti, solleciti e analisi finanziarie in tempo reale.", tags: ["Fatturazione", "Solleciti automatici", "Cash flow"] },
        { id: "hr", name: "HR Agent", desc: "Trova talenti, gestisce colloqui, onboarding e formazione del personale.", tags: ["Screening CV", "Colloqui AI", "Onboarding"] },
        { id: "executive", name: "Executive Agent", desc: "Il tuo assistente operativo. Ti aggiorna, ti avvisa e ti aiuta a prendere decisioni.", tags: ["Report giornalieri", "Alert intelligenti", "Pianificazione"] },
      ],
    },
    xos: {
      overline: "X OS — Il tuo sistema operativo aziendale",
      demoBadge: "Esempio dimostrativo",
      titleA: "Tutto sotto controllo.",
      titleNeon: "Sempre.",
      subtitle:
        "La dashboard di X OS ti mostra in tempo reale cosa stanno facendo i tuoi agenti AI e quali risultati stanno generando.",
      features: [
        { id: "visibilita", text: "Visibilità completa" },
        { id: "dati", text: "Dati in tempo reale" },
        { id: "decisioni", text: "Decisioni più rapide" },
        { id: "risultati", text: "Risultati misurabili" },
      ],
      overview: "Panoramica",
      today: "Oggi",
      goalsTitle: "Obiettivi mensili",
      stats: [
        { id: "agenti", label: "Agenti attivi", value: "12", delta: "+2 rispetto a ieri" },
        { id: "attivita", label: "Attività completate", value: "156", delta: "+12%" },
        { id: "lead", label: "Lead generati", value: "32", delta: "+8%" },
        { id: "preventivi", label: "Preventivi inviati", value: "5", delta: "+15%" },
      ],
      goals: [
        { label: "Fatturato", pct: 78, note: "" },
        { label: "Lead generati", pct: 61, note: "305 / 500" },
        { label: "Nuovi clienti", pct: 80, note: "40 / 50" },
      ],
    },
    projects: {
      overline: "Progetti",
      titleA: "I nostri lavori,",
      titleNeon: "presentati",
      subtitle: "Ogni progetto ha la sua storia. Apri le presentazioni per scoprire come li abbiamo costruiti.",
      loading: "Caricamento progetti...",
      empty: "Nuovi progetti in arrivo. Scrivici su WhatsApp per vedere i casi studio.",
      open: "Leggi la presentazione",
      close: "Chiudi la presentazione",
    },
    method: {
      overline: "Come funziona",
      titleA: "Il nostro metodo in",
      titleNeon: "5 step",
      steps: [
        { n: "01", title: "Analizziamo", desc: "Analizziamo i tuoi processi e identifichiamo le aree con più potenziale." },
        { n: "02", title: "Progettiamo", desc: "Disegniamo la strategia e definiamo gli agenti AI di cui hai bisogno." },
        { n: "03", title: "Costruiamo", desc: "Sviluppiamo e addestriamo gli agenti AI su misura per la tua azienda." },
        { n: "04", title: "Integriamo", desc: "Integriamo gli agenti AI nei tuoi strumenti e nei tuoi flussi operativi." },
        { n: "05", title: "Ottimizziamo", desc: "Monitoriamo le performance e miglioriamo costantemente i risultati." },
      ],
    },
    cta: {
      titleA: "Pronto a costruire il tuo",
      titleNeon: "team di dipendenti AI?",
      subtitle: "Prenota una consulenza gratuita con i nostri esperti e scopri come possiamo trasformare la tua azienda.",
      bullets: ["Consulenza gratuita senza impegno", "Soluzioni su misura per il tuo business", "Risultati misurabili, monitorati mese per mese"],
      whatsapp: "Scrivici su WhatsApp",
      whatsappMessage: "Ciao XS Consulting! Voglio prenotare una consulenza gratuita.",
      demo: "Prenota ora la demo",
    },
    footer: {
      tagline: "Il primo team di dipendenti AI per la tua azienda. Gestionali su misura, progettazione impianti e agenti AI — online, ovunque.",
      explore: "Esplora",
      contacts: "Contatti",
      rights: "© XSALES CONSULTING LTD — Tutti i diritti riservati",
      whatsappLabel: "WhatsApp: +41 78 204 21 72",
      legalSeat: "Sede legale",
      opSeat: "Sede operativa Svizzera",
    },
    assistant: {
      name: "Assistente XS",
      status: "Sempre attivo",
      steps: [
        "Ciao! Sono l'assistente di XS Consulting. Di cosa hai bisogno?",
        "Perfetto, {topic}. Come ti chiami?",
        "Grazie {name}! Raccontami in breve la tua esigenza.",
        "Tutto pronto! Apri WhatsApp e il messaggio è già compilato per te.",
      ],
      topics: [
        { id: "gestionale", label: "Gestionale su misura" },
        { id: "impianti", label: "Progettazione impianti" },
        { id: "agenti", label: "Agenti AI per la mia azienda" },
        { id: "altro", label: "Altro" },
      ],
      namePlaceholder: "Il tuo nome",
      luogoPlaceholder: "Es. Lugano, Svizzera",
      aziendaPlaceholder: "Nome azienda",
      contattoPlaceholder: "Email o telefono",
      messagePlaceholder: "Scrivi qui...",
      questions: {
        name: "Come ti chiami?",
        luogo: "Dove si trova la tua azienda? (città/paese)",
        azienda: "Come si chiama la tua azienda?",
        settore: "In quale settore operate?",
        contatto: "Qual è il tuo contatto? (email o telefono)",
        message: "Grazie {name}! Raccontami in breve la tua esigenza.",
      },
      settoreOptions: [
        { id: "industria", label: "Industria / Manifattura" },
        { id: "commercio", label: "Commercio / E-commerce" },
        { id: "servizi", label: "Servizi" },
        { id: "impianti", label: "Impianti / Costruzioni" },
        { id: "altro", label: "Altro" },
      ],
      open: "Apri WhatsApp",
      restart: "Ricomincia",
      direct: "Oppure scrivici direttamente su WhatsApp →",
      waMessage: "Ciao XS Consulting! Sono {name}. Azienda: {azienda} ({settore}) — {luogo}. Contatto: {contatto}. Mi interessa: {topic}. {message}",
      privacyNote: "Continuando accetti la nostra",
      freePlaceholder: "Scrivi una domanda libera...",
      or: "oppure",
      thinking: "Sto scrivendo...",
      continueWhatsApp: "Continua la conversazione su WhatsApp →",
      backToGuided: "← Torna alla guida",
      chatError: "Errore di connessione. Riprova o scrivici su WhatsApp.",
    },
    demo: {
      overline: "Demo gratuita",
      title: "Prenota la tua consulenza",
      namePh: "Nome e cognome",
      emailPh: "Email",
      companyPh: "Azienda",
      messagePh: "Di cosa hai bisogno?",
      sending: "Invio...",
      send: "Invia richiesta",
      success: "Richiesta inviata! Ti ricontattiamo a breve.",
      error: "Errore nell'invio. Riprova o scrivici su WhatsApp.",
      privacy: "Ho letto e accetto la",
    },
    academy: {
      overline: "XS Academy",
      titleA: "L'AI per imprenditori,",
      titleNeon: "spiegata in 10 lezioni",
      subtitle: "Un corso pratico per titolari e manager di PMI: niente teoria inutile, solo strumenti che puoi usare dal giorno dopo in azienda.",
      bullets: [
        "10 lezioni online, da seguire quando vuoi",
        "Casi reali di vendite, marketing, amministrazione e operations",
        "Prompt e modelli pronti da copiare",
        "Accesso alla community e alle sessioni di domande e risposte",
      ],
      ctaPrimary: "Scopri il corso",
      ctaSecondary: "Chiedi informazioni su WhatsApp",
      waMessage: "Ciao! Vorrei informazioni sul corso AI per imprenditori.",
      lessonsLabel: "10 lezioni online · quando vuoi",
    },
    academyPage: {
      back: "Torna alla home",
      metaTitle: "XS Academy — L'AI per imprenditori in 10 lezioni",
      programOverline: "Il programma",
      programTitle: "Le 10 lezioni",
      programSubtitle: "Un percorso completo: dalle basi dell'AI agli strumenti concreti per vendite, marketing, amministrazione e operations.",
      lessonLabel: "Lezione",
      lessons: [
        { title: "Cos'è davvero un agente AI (e cosa non è)", desc: "Capisci la differenza tra chatbot, automazione e agente AI, e cosa può fare oggi per la tua azienda." },
        { title: "Radiografia dell'azienda: mappare i processi", desc: "Impari a individuare le attività ripetitive di ogni reparto e quanto tempo ti costano ogni settimana." },
        { title: "Valutare i settori: dove l'AI rende di più", desc: "Con una matrice semplice scopri quali processi offrono il massimo risultato con il minimo sforzo." },
        { title: "Risk assessment prima di partire", desc: "Valuti dati, privacy e normative (GDPR, LPD, AI Act) per avviare l'AI in sicurezza e senza sorprese." },
        { title: "Business case e ROI", desc: "Calcoli costi, risparmi e tempi di rientro per decidere con numeri concreti, non con sensazioni." },
        { title: "Scegliere strumenti e partner", desc: "Scopri come orientarti tra soluzioni pronte, no-code e su misura, e quali domande fare ai fornitori." },
        { title: "Progettare il primo agente (il pilota)", desc: "Definisci cosa fa il tuo primo agente, con quali dati, quali limiti e quando interviene una persona." },
        { title: "Avvio del pilota: 30 giorni sotto controllo", desc: "Lanci il progetto in piccolo e misuri i risultati settimana dopo settimana con KPI chiari." },
        { title: "Le persone: formazione e gestione del cambiamento", desc: "Coinvolgi e formi il tuo team per trasformare l'AI in un alleato, non in una minaccia." },
        { title: "Valutare, correggere e scalare", desc: "Analizzi i risultati del pilota e costruisci la roadmap a 12 mesi per estendere l'AI a tutta l'azienda." },
      ],
      ctaOverline: "Corso gratuito",
      ctaTitle: "Ricevi le 10 lezioni gratuite via email",
      ctaText: "Lascia la tua email: ti mandiamo subito tutte le 10 lezioni, gratis. Niente spam, solo il corso.",
      emailPh: "La tua email",
      submit: "Ricevi le 10 lezioni gratuite",
      sending: "Invio in corso...",
      success: "Fatto! Controlla la tua casella email: le 10 lezioni sono in arrivo.",
      error: "Errore nell'invio. Riprova o scrivici su WhatsApp.",
      privacyNote: "Continuando accetti la nostra",
    },
    seo: {
      gestionale: { title: "Gestionali su misura per PMI in Svizzera | XS Consulting", desc: "ERP, CRM e software gestionali costruiti sui processi della tua azienda. Ordini, magazzino e fatturazione automatizzati. Consulenza gratuita." },
      impianti: { title: "Progettazione impianti: dal rilievo alla documentazione | XS Consulting", desc: "Progettazione e dimensionamento impianti con professionisti specializzati, dal rilievo alla documentazione tecnica esecutiva." },
      marketplace: { title: "Automazione Amazon, eBay e Zalando per venditori | XS Consulting", desc: "Catalogo, prezzi, magazzino e ordini sincronizzati su tutti i marketplace. Repricing intelligente e assistenza clienti con AI." },
      academy: { title: "Corso AI per imprenditori e PMI in 10 lezioni | XS Academy", desc: "Corso pratico online per titolari e manager: come usare l'AI in vendite, marketing e amministrazione e come avviare un agente AI in azienda." },
      blog: { title: "Blog — Guide e approfondimenti AI | XS Consulting", desc: "Guide pratiche su agenti AI, gestionali su misura e automazione per PMI: casi reali, strumenti e strategie." },
    },
    agentsService: {
      chip: "AI Agents",
      h1: "Agenti AI su misura per PMI",
      subtitle: "Un team di agenti AI che lavora 24/7 insieme al tuo: vendite, amministrazione e assistenza clienti vanno avanti anche quando sei offline.",
      metaTitle: "Agenti AI per PMI: automatizza vendite, amministrazione e clienti | XS Consulting",
      metaDesc: "Agenti AI su misura che lavorano 24/7 con il tuo team: preventivi, follow-up, assistenza clienti, fatture e reportistica. Consulenza gratuita.",
      waMessage: "Ciao XS Consulting! Vorrei una consulenza gratuita sugli agenti AI per la mia azienda.",
      problemaTitle: "Il problema",
      problemaText: "Ogni settimana la tua azienda perde ore in attività ripetitive: preventivi da scrivere, clienti da ricontattare, fatture da sollecitare, report da compilare. Ore sottratte a vendita e crescita.",
      soluzioneTitle: "La soluzione",
      soluzioneText: "Un team di agenti AI su misura, collegati agli strumenti che già usi — gestionale, email, WhatsApp, e-commerce. Lavorano 24 ore su 24, seguono i tuoi processi e passano la palla a una persona quando serve.",
      automationsTitle: "Cosa automatizzano",
      automations: [
        { title: "Preventivi", desc: "Generati e inviati in automatico dai dati della richiesta del cliente." },
        { title: "Follow-up", desc: "Ricontatti programmati via email e WhatsApp: nessun cliente dimenticato." },
        { title: "Assistenza clienti", desc: "Risposte immediate su WhatsApp ed email, 24 ore su 24." },
        { title: "Fatture e solleciti", desc: "Emissione fatture, promemoria di pagamento e solleciti automatici." },
        { title: "Ordini", desc: "Dall'ordine alla conferma: aggiornamenti di stato senza interventi manuali." },
        { title: "Report", desc: "Reportistica di vendite e performance pronta ogni giorno nella tua dashboard." },
      ],
      agentsTitle: "I 6 agenti del tuo team",
      integrationsTitle: "Integrazioni",
      integrationsText: "Gli agenti si collegano agli strumenti che usi già: gestionali ed ERP, CRM, email, WhatsApp Business, e-commerce e marketplace, contabilità. Nessuna rivoluzione: si innestano sui tuoi processi.",
      faqTitle: "Domande frequenti",
      faq: [
        { q: "Quanto costa?", a: "Dipende dal numero di agenti e dalle integrazioni. La consulenza iniziale è gratuita: analizziamo i tuoi processi e ricevi un preventivo chiaro prima di partire." },
        { q: "In quanto tempo è operativo?", a: "Il primo agente pilota è tipicamente operativo in 2-4 settimane, con misurazione dei risultati già nei primi 30 giorni." },
        { q: "Devo cambiare software?", a: "No. Gli agenti si collegano agli strumenti che usi già: gestionale, email, WhatsApp, e-commerce. Se manca qualcosa, lo costruiamo su misura." },
        { q: "I dati sono al sicuro?", a: "Sì: lavoriamo nel rispetto di GDPR, UK GDPR e nLPD, con accessi controllati e connessioni cifrate. I tuoi dati restano tuoi." },
        { q: "Posso partire da un solo agente?", a: "Certo. Si parte da un pilota su un processo singolo, si misurano i risultati e poi si scala al resto dell'azienda." },
      ],
      ctaOverline: "Parliamone",
      ctaTitle: "Pronto ad automatizzare la tua azienda?",
      ctaText: "Prenota una consulenza gratuita: analizziamo insieme i tuoi processi e ti diciamo dove un agente AI rende di più.",
    },
    contatti: {
      metaTitle: "Contatti — XS Consulting, Manno (Ticino)",
      metaDesc: "Contatta XS Consulting: Via Cantonale 38, 6928 Manno TI, Svizzera. Tel e WhatsApp +41 78 204 21 72. Consulenza gratuita su agenti AI e gestionali su misura.",
      h1: "Parliamone",
      subtitle: "Siamo a Manno, in Ticino — e online ovunque. Chiamaci, scrivici su WhatsApp o lascia un messaggio: rispondiamo entro 24 ore lavorative.",
      addressTitle: "Sede operativa",
      formTitle: "Scrivici un messaggio",
      namePh: "Nome e cognome",
      emailPh: "Email",
      messagePh: "Come possiamo aiutarti?",
      submit: "Invia messaggio",
      sending: "Invio...",
      success: "Messaggio inviato! Ti ricontattiamo entro 24 ore lavorative.",
      error: "Errore nell'invio. Riprova o scrivici su WhatsApp.",
      privacyNote: "Continuando accetti la nostra",
      whatsappCta: "Scrivici su WhatsApp",
      waMessage: "Ciao XS Consulting! Vi contatto dal sito: vorrei maggiori informazioni.",
    },
    servicePages: {
      back: "Torna alla home",
      perChiTitle: "Per chi è",
      howTitle: "Come lavoriamo",
      examplesTitle: "Esempi concreti",
      faqTitle: "Domande frequenti",
      whatOverline: "Cosa facciamo",
      whyTitle: "Perché sceglierci",
      ctaOverline: "Parliamone",
      ctaTitle: "Raccontaci il tuo progetto",
      ctaText: "Una consulenza gratuita per capire insieme come automatizzare e far crescere la tua azienda.",
      ctaPrimary: "Prenota una consulenza gratuita",
      ctaSecondary: "Parla con l'assistente AI",
      services: {
        gestionale: {
          chip: "Software",
          title: "Gestionali su misura",
          subtitle: "Non adattiamo la tua azienda a un software: costruiamo il software attorno alla tua azienda. ERP, CRM e piattaforme operative disegnate sui tuoi processi.",
          metaTitle: "Gestionali su misura — XS Consulting",
          features: [
            { title: "Analisi dei processi", desc: "Mappiamo i tuoi flussi di lavoro reali prima di scrivere una riga di codice." },
            { title: "ERP e CRM su misura", desc: "Clienti, ordini, magazzino e fatturazione in un unico strumento costruito per te." },
            { title: "Automazioni operative", desc: "Eliminiamo le attività ripetitive con flussi automatici e agenti AI." },
            { title: "Dashboard direzionale", desc: "Vendite, magazzino e performance in tempo reale, sempre sotto controllo." },
            { title: "Integrazioni", desc: "Colleghiamo il gestionale agli strumenti che già usi: e-commerce, contabilità, email." },
            { title: "Formazione e supporto", desc: "Affianchiamo il tuo team dopo il go-live, con assistenza continua." },
          ],
          why: "Ogni gestionale è costruito sui tuoi processi e cresce con la tua azienda: niente licenze inutili, niente funzioni che non userai mai. E con i nostri agenti AI integrati, il software lavora per te anche quando sei offline.",
          perChi: "Per titolari e manager di PMI in Svizzera e in Ticino che perdono ore ogni settimana tra fogli Excel, ordini sparsi e fatturazione manuale — e vogliono un unico strumento costruito sui loro processi, non il contrario.",
          examples: [
            "Un'officina del Luganese che gestisce commesse, ore e fatture in un'unica dashboard",
            "Un e-commerce ticinese che sincronizza magazzino e ordini tra shop e gestionale",
            "Uno studio di servizi che automatizza preventivi e solleciti di pagamento",
          ],
          faq: [
            { q: "Quanto costa un gestionale su misura?", a: "Dipende da moduli e integrazioni. Dopo la consulenza gratuita ricevi un preventivo chiuso, senza sorprese." },
            { q: "Quanto tempo serve?", a: "Una prima versione operativa in genere in 4-8 settimane, poi si estende modulo per modulo." },
            { q: "Posso importare i dati dal mio vecchio gestionale?", a: "Sì, migriamo dati da Excel, CSV e dai principali gestionali usati in Svizzera." },
            { q: "Funziona con la fatturazione svizzera (QR-fattura)?", a: "Sì, supportiamo la QR-fattura e gli standard svizzeri di fatturazione." },
            { q: "E se il mio processo cambia?", a: "Il software è modulare: si adatta e cresce con la tua azienda, con assistenza continua dal nostro team in Ticino." },
          ],
        },
        impianti: {
          chip: "Ingegneria",
          title: "Progettazione impianti",
          subtitle: "Professionisti veri della progettazione impianti: dal rilievo al dimensionamento, fino alla documentazione tecnica esecutiva.",
          metaTitle: "Progettazione impianti — XS Consulting",
          features: [
            { title: "Rilievo e analisi", desc: "Sopralluogo e raccolta delle esigenze tecniche, funzionali e normative." },
            { title: "Dimensionamento", desc: "Calcoli e scelte progettuali nel rispetto delle norme vigenti." },
            { title: "Schemi esecutivi", desc: "Elaborati grafici chiari e pronti per la realizzazione." },
            { title: "Documentazione tecnica", desc: "Relazioni, capitolati e fascicoli completi, sempre in ordine." },
            { title: "Coordinamento digitale", desc: "Commesse, revisioni e consegne gestite in un unico flusso digitale." },
            { title: "Supporto in cantiere", desc: "Assistenza durante la realizzazione e il collaudo finale." },
          ],
          why: "Uniamo l'esperienza di professionisti della progettazione alla velocità degli strumenti digitali: tempi certi, documenti sempre in ordine e un unico interlocutore per tutta la commessa.",
          perChi: "Per imprese di costruzione, installatori e studi tecnici in Ticino e in Svizzera che hanno bisogno di progetti a norma, documentazione in ordine e tempi certi.",
          examples: [
            "Progettazione degli impianti elettrici per una nuova residenza a Manno",
            "Dimensionamento e schemi esecutivi per la ristrutturazione di uno stabile commerciale a Lugano",
            "Documentazione tecnica e coordinamento digitale per una commessa multi-impianto",
          ],
          faq: [
            { q: "Lavorate in tutta la Svizzera?", a: "Siamo in Ticino e operiamo su tutto il territorio svizzero, con sopralluoghi concordati." },
            { q: "Conoscete le norme svizzere (NIN, SIA)?", a: "Sì, i progetti seguono le norme vigenti in Svizzera e la documentazione è completa per gli enti competenti." },
            { q: "Potete partire da un rilievo esistente?", a: "Sì: possiamo validare un rilievo esistente oppure eseguirne uno nuovo sul posto." },
            { q: "Quanto dura una progettazione?", a: "Dipende dall'entità della commessa: dopo una prima analisi ti diamo tempi chiari e impegnativi." },
            { q: "Fate anche direzione lavori?", a: "Su richiesta affianchiamo la fase di realizzazione e il collaudo finale." },
          ],
        },
        marketplace: {
          chip: "E-commerce",
          title: "Automazione per chi vende sui Marketplace",
          subtitle: "Vendi su Amazon, eBay o Zalando? Automatizziamo le operazioni ripetitive, così tu ti concentri sulla crescita.",
          metaTitle: "Automazione Marketplace — XS Consulting",
          features: [
            { title: "Gestione catalogo", desc: "Caricamento e aggiornamento di prodotti, prezzi e descrizioni su più marketplace insieme." },
            { title: "Sincronizzazione magazzino", desc: "Scorte allineate in tempo reale: niente più vendite di prodotti esauriti." },
            { title: "Ordini e spedizioni", desc: "Flusso automatico dall'ordine all'etichetta di spedizione." },
            { title: "Repricing intelligente", desc: "Prezzi adattati alla concorrenza secondo le tue regole." },
            { title: "Assistenza clienti con AI", desc: "Risposte automatiche alle domande frequenti e ai messaggi degli acquirenti." },
            { title: "Report e analisi", desc: "Vendite, margini e performance in un'unica dashboard." },
          ],
          why: "Colleghiamo i marketplace al tuo gestionale e ai tuoi strumenti, con agenti AI su misura per il tuo business.",
          perChi: "Per venditori e brand in Svizzera e in Italia che vendono su Amazon, eBay o Zalando e passano troppe ore tra cataloghi, prezzi e spedizioni.",
          examples: [
            "Un venditore ticinese che ha ridotto del 90% gli errori di giacenza tra Amazon e il suo gestionale",
            "Un brand che aggiorna 2'000 prezzi al giorno con regole di repricing automatiche",
            "Un e-commerce che risponde ai clienti in 3 lingue con un agente AI",
          ],
          faq: [
            { q: "Con quali marketplace lavorate?", a: "Amazon, eBay, Zalando e altri su richiesta, tutti collegati al tuo gestionale." },
            { q: "Devo cambiare gestionale?", a: "No: ci colleghiamo a quello che usi già. Se manca un pezzo, costruiamo noi il ponte." },
            { q: "Il repricing può scendere sotto il mio margine?", a: "No: le regole le definisci tu, con prezzi minimi e massimi invalicabili." },
            { q: "In quanto tempo è attivo?", a: "Le prime sincronizzazioni sono in genere operative entro 2-4 settimane." },
            { q: "Posso partire da un solo marketplace?", a: "Sì, poi aggiungiamo gli altri uno alla volta, misurando i risultati." },
          ],
        },
      },
    },
  },
  en: {
    meta: {
      title: "Custom software & AI agent teams — XS Consulting",
      description: "XS Consulting builds teams of AI employees, custom management software and plant design for companies in Switzerland and worldwide. Message us on WhatsApp.",
    },
    common: {
      waDefault: "Hi XS Consulting! I'd like more information.",
      welcome: "Welcome back to XS Consulting. If you like, I'll guide you myself: open the assistant at the bottom right and I'll show you what we can build for your company.",
      welcomeCta: "Play the voice welcome",
    },
    nav: {
      links: [
        { href: "#servizi", id: "servizi", label: "Services" },
        { href: "#agenti", id: "agenti", label: "AI Agents" },
        { href: "#progetti", id: "progetti", label: "Projects" },
        { href: "#academy", id: "academy", label: "Academy" },
        { href: "#metodo", id: "metodo", label: "Method" },
        { href: "/blog", id: "blog", label: "Blog" },
      ],
      whatsapp: "WhatsApp",
      demo: "Book a demo",
    },
    hero: {
      overline: "We engineer your business future",
      h1Plain: "AI agents and custom management software for SMEs in Switzerland",
      h1a: ["AI", "agents", "and"],
      h1neon: ["custom", "management", "software"],
      h1b: ["for", "SMEs", "in", "Switzerland"],
      subtitle:
        "We build the first team of AI employees for your company. Our AI agents work alongside your team, automate processes and collaborate with each other 24/7. Tailor-made solutions, not off-the-shelf packages.",
      whatsapp: "Message us on WhatsApp",
      whatsappMessage: "Hi XS Consulting! I'd like more information about your AI agent team.",
      demo: "Book a free demo",
      claim: "Over 50 companies have already transformed their business with us.",
    },
    marquee: {
      label: "We integrate with the tools you use every day",
    },
    cookies: {
      title: "Cookies & privacy",
      text: "We use technical cookies and, with your consent, analytics tools to improve the site.",
      accept: "Accept",
      reject: "Reject",
    },
    expertise: {
      overline: "What we do",
      titleA: "Tailor-made solutions,",
      titleNeon: "not off-the-shelf packages",
      subtitle:
        "Three souls, one method: management software built around your processes, plant design handled by true professionals, and automation for marketplace sellers. Online, wherever you are.",
      cards: {
        gestionale: {
          chip: "Software",
          title: "Custom management software",
          desc: "We don't adapt your company to a software: we build the software around your company. ERP, CRM and operational platforms designed around your processes.",
          bullets: [
            "ERP and CRM built on your workflows",
            "Automation of orders, warehouse and invoicing",
            "Executive dashboard with real-time data",
            "Integration with the tools you already use",
          ],
        },
        impianti: {
          chip: "Engineering",
          title: "Plant design",
          desc: "True plant design professionals: from site survey to sizing, through to executive technical documentation.",
          bullets: [
            "Survey and needs analysis",
            "Sizing and executive schematics",
            "Complete technical documentation",
            "Digital job coordination",
          ],
        },
        marketplace: {
          chip: "E-commerce",
          title: "Marketplace Automation",
          desc: "Selling on Amazon, eBay or Zalando? We automate the repetitive work, so you can focus on growth.",
          bullets: [
            "Catalogue and prices synced across marketplaces",
            "Inventory aligned in real time",
            "Smart repricing and automatic orders",
            "AI-powered customer support",
          ],
        },
      },
      cta: "Explore the service",
    },
    agents: {
      overline: "Our AI agents",
      titleA: "A complete team of",
      titleNeon: "AI agents",
      subtitle:
        "Each agent is specialised. Connected to the central brain, they collaborate with each other 24 hours a day. Together they are unbeatable.",
      list: [
        { id: "sales", name: "Sales Agent", desc: "Analyses customers, sends personalised emails, manages follow-ups and closes sales.", tags: ["Lead research", "Email & LinkedIn", "Automatic quotes"] },
        { id: "marketing", name: "Marketing Agent", desc: "Creates campaigns, manages content and analyses performance.", tags: ["Content creation", "Email marketing", "ROI analysis"] },
        { id: "operations", name: "Operations Agent", desc: "Manages processes, tasks, tickets, documents and operational workflows.", tags: ["Task management", "Ticketing system", "Reporting"] },
        { id: "finance", name: "Finance Agent", desc: "Handles invoices, payments, reminders and real-time financial analysis.", tags: ["Invoicing", "Automatic reminders", "Cash flow"] },
        { id: "hr", name: "HR Agent", desc: "Finds talent, manages interviews, onboarding and staff training.", tags: ["CV screening", "AI interviews", "Onboarding"] },
        { id: "executive", name: "Executive Agent", desc: "Your operational assistant. Keeps you updated, alerts you and helps you make decisions.", tags: ["Daily reports", "Smart alerts", "Planning"] },
      ],
    },
    xos: {
      overline: "X OS — Your company operating system",
      demoBadge: "Demo example",
      titleA: "Everything under control.",
      titleNeon: "Always.",
      subtitle:
        "The X OS dashboard shows you in real time what your AI agents are doing and what results they are generating.",
      features: [
        { id: "visibilita", text: "Complete visibility" },
        { id: "dati", text: "Real-time data" },
        { id: "decisioni", text: "Faster decisions" },
        { id: "risultati", text: "Measurable results" },
      ],
      overview: "Overview",
      today: "Today",
      goalsTitle: "Monthly goals",
      stats: [
        { id: "agenti", label: "Active agents", value: "12", delta: "+2 vs yesterday" },
        { id: "attivita", label: "Completed activities", value: "156", delta: "+12%" },
        { id: "lead", label: "Leads generated", value: "32", delta: "+8%" },
        { id: "preventivi", label: "Quotes sent", value: "5", delta: "+15%" },
      ],
      goals: [
        { label: "Revenue", pct: 78, note: "" },
        { label: "Leads generated", pct: 61, note: "305 / 500" },
        { label: "New clients", pct: 80, note: "40 / 50" },
      ],
    },
    projects: {
      overline: "Projects",
      titleA: "Our work,",
      titleNeon: "presented",
      subtitle: "Every project has its story. Open the presentations to see how we built them.",
      loading: "Loading projects...",
      empty: "New projects coming soon. Message us on WhatsApp to see our case studies.",
      open: "Read the presentation",
      close: "Close the presentation",
    },
    method: {
      overline: "How it works",
      titleA: "Our method in",
      titleNeon: "5 steps",
      steps: [
        { n: "01", title: "We analyse", desc: "We analyse your processes and identify the areas with the most potential." },
        { n: "02", title: "We design", desc: "We design the strategy and define the AI agents you need." },
        { n: "03", title: "We build", desc: "We develop and train AI agents tailored to your company." },
        { n: "04", title: "We integrate", desc: "We integrate AI agents into your tools and operational workflows." },
        { n: "05", title: "We optimise", desc: "We monitor performance and constantly improve results." },
      ],
    },
    cta: {
      titleA: "Ready to build your",
      titleNeon: "team of AI employees?",
      subtitle: "Book a free consultation with our experts and discover how we can transform your company.",
      bullets: ["Free consultation, no obligation", "Tailor-made solutions for your business", "Measurable results, monitored month by month"],
      whatsapp: "Message us on WhatsApp",
      whatsappMessage: "Hi XS Consulting! I'd like to book a free consultation.",
      demo: "Book the demo now",
    },
    footer: {
      tagline: "The first team of AI employees for your company. Custom management software, plant design and AI agents — online, anywhere.",
      explore: "Explore",
      contacts: "Contacts",
      rights: "© XSALES CONSULTING LTD — All rights reserved",
      whatsappLabel: "WhatsApp: +41 78 204 21 72",
      legalSeat: "Registered office",
      opSeat: "Swiss operating office",
    },
    assistant: {
      name: "XS Assistant",
      status: "Always active",
      steps: [
        "Hi! I'm the XS Consulting assistant. What do you need?",
        "Great, {topic}. What's your name?",
        "Thanks {name}! Briefly tell me about your needs.",
        "All set! Open WhatsApp and your message is already drafted for you.",
      ],
      topics: [
        { id: "gestionale", label: "Custom management software" },
        { id: "impianti", label: "Plant design" },
        { id: "agenti", label: "AI agents for my company" },
        { id: "altro", label: "Something else" },
      ],
      namePlaceholder: "Your name",
      luogoPlaceholder: "E.g. Zurich, Switzerland",
      aziendaPlaceholder: "Company name",
      contattoPlaceholder: "Email or phone",
      messagePlaceholder: "Type here...",
      questions: {
        name: "What's your name?",
        luogo: "Where is your company located? (city/country)",
        azienda: "What's your company called?",
        settore: "What industry are you in?",
        contatto: "How can we reach you? (email or phone)",
        message: "Thanks {name}! Briefly tell me about your needs.",
      },
      settoreOptions: [
        { id: "industria", label: "Industry / Manufacturing" },
        { id: "commercio", label: "Commerce / E-commerce" },
        { id: "servizi", label: "Services" },
        { id: "impianti", label: "Plant / Construction" },
        { id: "altro", label: "Other" },
      ],
      open: "Open WhatsApp",
      restart: "Start over",
      direct: "Or message us directly on WhatsApp →",
      waMessage: "Hi XS Consulting! I'm {name}. Company: {azienda} ({settore}) — {luogo}. Contact: {contatto}. I'm interested in: {topic}. {message}",
      privacyNote: "By continuing you accept our",
      freePlaceholder: "Ask a free question...",
      or: "or",
      thinking: "Writing...",
      continueWhatsApp: "Continue the conversation on WhatsApp →",
      backToGuided: "← Back to the guide",
      chatError: "Connection error. Try again or message us on WhatsApp.",
    },
    demo: {
      overline: "Free demo",
      title: "Book your consultation",
      namePh: "Full name",
      emailPh: "Email",
      companyPh: "Company",
      messagePh: "What do you need?",
      sending: "Sending...",
      send: "Send request",
      success: "Request sent! We'll get back to you shortly.",
      error: "Sending failed. Try again or message us on WhatsApp.",
      privacy: "I have read and accept the",
    },
    academy: {
      overline: "XS Academy",
      titleA: "AI for entrepreneurs,",
      titleNeon: "explained in 10 lessons",
      subtitle: "A practical course for SME owners and managers: no useless theory, only tools you can use in your business the very next day.",
      bullets: [
        "10 online lessons, follow them whenever you want",
        "Real cases from sales, marketing, admin and operations",
        "Ready-to-copy prompts and templates",
        "Access to the community and Q&A sessions",
      ],
      ctaPrimary: "Discover the course",
      ctaSecondary: "Ask for info on WhatsApp",
      waMessage: "Hi! I'd like information about the AI course for entrepreneurs.",
      lessonsLabel: "10 online lessons · whenever you want",
    },
    academyPage: {
      back: "Back to home",
      metaTitle: "XS Academy — AI for entrepreneurs in 10 lessons",
      programOverline: "The programme",
      programTitle: "The 10 lessons",
      programSubtitle: "A complete path: from AI basics to concrete tools for sales, marketing, admin and operations.",
      lessonLabel: "Lesson",
      lessons: [
        { title: "What an AI agent really is (and what it isn't)", desc: "Understand the difference between a chatbot, automation and an AI agent, and what it can do for your business today." },
        { title: "Company X-ray: mapping your processes", desc: "Learn to spot the repetitive tasks in every department and how much time they cost you each week." },
        { title: "Assessing departments: where AI pays off most", desc: "With a simple matrix, discover which processes deliver the maximum result with the minimum effort." },
        { title: "Risk assessment before you start", desc: "Assess data, privacy and regulations (GDPR, LPD, AI Act) to launch AI safely and without surprises." },
        { title: "Business case and ROI", desc: "Calculate costs, savings and payback time to decide with concrete numbers, not gut feelings." },
        { title: "Choosing tools and partners", desc: "Learn how to navigate ready-made, no-code and custom solutions, and which questions to ask vendors." },
        { title: "Designing the first agent (the pilot)", desc: "Define what your first agent does, with which data, which limits, and when a human steps in." },
        { title: "Pilot launch: 30 days under control", desc: "Launch the project small and measure results week after week with clear KPIs." },
        { title: "People: training and change management", desc: "Engage and train your team to turn AI into an ally, not a threat." },
        { title: "Evaluate, correct and scale", desc: "Analyse the pilot results and build the 12-month roadmap to extend AI across the whole company." },
      ],
      ctaOverline: "Free course",
      ctaTitle: "Get the 10 free lessons by email",
      ctaText: "Leave your email: we'll send you all 10 lessons straight away, free. No spam, just the course.",
      emailPh: "Your email",
      submit: "Get the 10 free lessons",
      sending: "Sending...",
      success: "Done! Check your inbox: the 10 lessons are on their way.",
      error: "Sending failed. Try again or message us on WhatsApp.",
      privacyNote: "By continuing you accept our",
    },
    seo: {
      gestionale: { title: "Custom management software for SMEs in Switzerland | XS Consulting", desc: "ERP, CRM and management software built around your company's processes. Orders, warehouse and invoicing automated. Free consultation." },
      impianti: { title: "Plant design: from site survey to documentation | XS Consulting", desc: "Plant design and sizing with specialised professionals, from site survey to executive technical documentation." },
      marketplace: { title: "Amazon, eBay and Zalando automation for sellers | XS Consulting", desc: "Catalogue, prices, inventory and orders synced across all marketplaces. Smart repricing and AI customer support." },
      academy: { title: "AI course for entrepreneurs and SMEs in 10 lessons | XS Academy", desc: "Practical online course for owners and managers: how to use AI in sales, marketing and admin, and how to launch an AI agent in your company." },
      blog: { title: "Blog — AI guides and insights | XS Consulting", desc: "Practical guides on AI agents, custom management software and automation for SMEs: real cases, tools and strategies." },
    },
    agentsService: {
      chip: "AI Agents",
      h1: "Custom AI agents for SMEs",
      subtitle: "A team of AI agents working 24/7 alongside yours: sales, admin and customer support keep moving even when you're offline.",
      metaTitle: "AI agents for SMEs: automate sales, admin and customers | XS Consulting",
      metaDesc: "Custom AI agents working 24/7 with your team: quotes, follow-ups, customer support, invoicing and reporting. Free consultation.",
      waMessage: "Hi XS Consulting! I'd like a free consultation about AI agents for my company.",
      problemaTitle: "The problem",
      problemaText: "Every week your company loses hours to repetitive tasks: quotes to write, customers to call back, invoices to chase, reports to compile. Hours taken away from selling and growing.",
      soluzioneTitle: "The solution",
      soluzioneText: "A team of custom AI agents connected to the tools you already use — management software, email, WhatsApp, e-commerce. They work 24 hours a day, follow your processes and hand over to a human when needed.",
      automationsTitle: "What they automate",
      automations: [
        { title: "Quotes", desc: "Generated and sent automatically from the customer's request data." },
        { title: "Follow-ups", desc: "Scheduled callbacks via email and WhatsApp: no customer forgotten." },
        { title: "Customer support", desc: "Instant answers on WhatsApp and email, 24 hours a day." },
        { title: "Invoices & reminders", desc: "Invoice issuing, payment reminders and automatic dunning." },
        { title: "Orders", desc: "From order to confirmation: status updates without manual work." },
        { title: "Reports", desc: "Sales and performance reporting ready every day in your dashboard." },
      ],
      agentsTitle: "The 6 agents in your team",
      integrationsTitle: "Integrations",
      integrationsText: "The agents connect to the tools you already use: ERP and management software, CRM, email, WhatsApp Business, e-commerce and marketplaces, accounting. No revolution: they plug into your processes.",
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "How much does it cost?", a: "It depends on the number of agents and integrations. The initial consultation is free: we analyse your processes and you get a clear quote before starting." },
        { q: "How quickly is it up and running?", a: "The first pilot agent is typically operational within 2–4 weeks, with results measured in the first 30 days." },
        { q: "Do I have to change software?", a: "No. The agents connect to the tools you already use: management software, email, WhatsApp, e-commerce. If something is missing, we build it custom." },
        { q: "Is my data safe?", a: "Yes: we work in compliance with GDPR, UK GDPR and nFADP, with controlled access and encrypted connections. Your data stays yours." },
        { q: "Can I start with just one agent?", a: "Of course. You start with a pilot on a single process, measure the results, then scale to the rest of the company." },
      ],
      ctaOverline: "Let's talk",
      ctaTitle: "Ready to automate your business?",
      ctaText: "Book a free consultation: we'll analyse your processes together and show you where an AI agent pays off most.",
    },
    contatti: {
      metaTitle: "Contact — XS Consulting, Manno (Ticino)",
      metaDesc: "Contact XS Consulting: Via Cantonale 38, 6928 Manno TI, Switzerland. Phone & WhatsApp +41 78 204 21 72. Free consultation on AI agents and custom management software.",
      h1: "Let's talk",
      subtitle: "We are in Manno, Ticino — and online everywhere. Call us, message us on WhatsApp or leave a message: we reply within 24 working hours.",
      addressTitle: "Operating office",
      formTitle: "Send us a message",
      namePh: "Full name",
      emailPh: "Email",
      messagePh: "How can we help?",
      submit: "Send message",
      sending: "Sending...",
      success: "Message sent! We'll get back to you within 24 working hours.",
      error: "Sending failed. Try again or message us on WhatsApp.",
      privacyNote: "By continuing you accept our",
      whatsappCta: "Message us on WhatsApp",
      waMessage: "Hi XS Consulting! I'm contacting you from the website: I'd like more information.",
    },
    servicePages: {
      back: "Back to home",
      perChiTitle: "Who it's for",
      howTitle: "How we work",
      examplesTitle: "Real-world examples",
      faqTitle: "Frequently asked questions",
      whatOverline: "What we do",
      whyTitle: "Why choose us",
      ctaOverline: "Let's talk",
      ctaTitle: "Tell us about your project",
      ctaText: "A free consultation to figure out together how to automate and grow your business.",
      ctaPrimary: "Book a free consultation",
      ctaSecondary: "Talk to the AI assistant",
      services: {
        gestionale: {
          chip: "Software",
          title: "Custom management software",
          subtitle: "We don't adapt your company to a software: we build the software around your company. ERP, CRM and operational platforms designed around your processes.",
          metaTitle: "Custom management software — XS Consulting",
          features: [
            { title: "Process analysis", desc: "We map your real workflows before writing a single line of code." },
            { title: "Custom ERP & CRM", desc: "Customers, orders, warehouse and invoicing in a single tool built for you." },
            { title: "Operational automation", desc: "We eliminate repetitive tasks with automated workflows and AI agents." },
            { title: "Executive dashboard", desc: "Sales, warehouse and performance in real time, always under control." },
            { title: "Integrations", desc: "We connect the software to the tools you already use: e-commerce, accounting, email." },
            { title: "Training & support", desc: "We support your team after go-live, with ongoing assistance." },
          ],
          why: "Every system is built on your processes and grows with your company: no useless licences, no features you'll never use. And with our integrated AI agents, the software works for you even when you're offline.",
          perChi: "For owners and managers of SMEs in Switzerland and Ticino who lose hours every week between spreadsheets, scattered orders and manual invoicing — and want a single tool built around their processes, not the other way round.",
          examples: [
            "A workshop in the Lugano area managing jobs, hours and invoices in a single dashboard",
            "A Ticino e-commerce syncing stock and orders between shop and management software",
            "A service firm automating quotes and payment reminders",
          ],
          faq: [
            { q: "How much does custom management software cost?", a: "It depends on modules and integrations. After the free consultation you get a fixed quote, no surprises." },
            { q: "How long does it take?", a: "A first working version is typically ready in 4–8 weeks, then it grows module by module." },
            { q: "Can I import data from my old system?", a: "Yes, we migrate data from Excel, CSV and the main management systems used in Switzerland." },
            { q: "Does it support Swiss invoicing (QR-bill)?", a: "Yes, we support QR-bills and Swiss invoicing standards." },
            { q: "What if my process changes?", a: "The software is modular: it adapts and grows with your company, with ongoing support from our team in Ticino." },
          ],
        },
        impianti: {
          chip: "Engineering",
          title: "Plant design",
          subtitle: "True plant design professionals: from site survey to sizing, through to executive technical documentation.",
          metaTitle: "Plant design — XS Consulting",
          features: [
            { title: "Survey & analysis", desc: "On-site survey and collection of technical, functional and regulatory requirements." },
            { title: "Sizing", desc: "Calculations and design choices in compliance with current regulations." },
            { title: "Executive schematics", desc: "Clear drawings ready for construction." },
            { title: "Technical documentation", desc: "Reports, specifications and complete files, always in order." },
            { title: "Digital coordination", desc: "Jobs, revisions and deliveries managed in a single digital flow." },
            { title: "On-site support", desc: "Assistance during construction and final acceptance testing." },
          ],
          why: "We combine the experience of design professionals with the speed of digital tools: reliable timelines, always-organised documents and a single point of contact for the whole project.",
          perChi: "For construction companies, installers and engineering firms in Ticino and Switzerland that need compliant designs, tidy documentation and reliable timelines.",
          examples: [
            "Electrical systems design for a new residence in Manno",
            "Sizing and executive schematics for the renovation of a commercial building in Lugano",
            "Technical documentation and digital coordination for a multi-system project",
          ],
          faq: [
            { q: "Do you work all over Switzerland?", a: "We are based in Ticino and operate across Switzerland, with site surveys by arrangement." },
            { q: "Are you familiar with Swiss standards (NIN, SIA)?", a: "Yes, our designs follow the regulations in force in Switzerland and the documentation is complete for the competent authorities." },
            { q: "Can you start from an existing survey?", a: "Yes: we can validate an existing survey or carry out a new one on site." },
            { q: "How long does a design take?", a: "It depends on the size of the job: after an initial analysis we give you a clear, committed timeline." },
            { q: "Do you also handle works supervision?", a: "On request we support the construction phase and final acceptance testing." },
          ],
        },
        marketplace: {
          chip: "E-commerce",
          title: "Automation for Marketplace sellers",
          subtitle: "Selling on Amazon, eBay or Zalando? We automate the repetitive work, so you can focus on growth.",
          metaTitle: "Marketplace Automation — XS Consulting",
          features: [
            { title: "Catalogue management", desc: "Upload and update products, prices and descriptions across multiple marketplaces at once." },
            { title: "Inventory sync", desc: "Stock levels aligned in real time: no more selling out-of-stock products." },
            { title: "Orders & shipping", desc: "Automatic flow from order to shipping label." },
            { title: "Smart repricing", desc: "Prices adapted to the competition according to your rules." },
            { title: "AI customer support", desc: "Automatic replies to frequent questions and buyer messages." },
            { title: "Reports & analytics", desc: "Sales, margins and performance in a single dashboard." },
          ],
          why: "We connect marketplaces to your management software and tools, with AI agents tailored to your business.",
          perChi: "For sellers and brands in Switzerland and Italy selling on Amazon, eBay or Zalando who spend too many hours on catalogues, prices and shipping.",
          examples: [
            "A Ticino seller who cut stock errors between Amazon and their management system by 90%",
            "A brand updating 2,000 prices a day with automatic repricing rules",
            "An e-commerce answering customers in 3 languages with an AI agent",
          ],
          faq: [
            { q: "Which marketplaces do you work with?", a: "Amazon, eBay, Zalando and others on request, all connected to your management software." },
            { q: "Do I need to change my management software?", a: "No: we connect to what you already use. If something is missing, we build the bridge." },
            { q: "Can repricing go below my margin?", a: "No: you define the rules, with minimum and maximum prices that cannot be crossed." },
            { q: "How quickly is it up and running?", a: "The first synchronisations are typically live within 2–4 weeks." },
            { q: "Can I start with just one marketplace?", a: "Yes, then we add the others one at a time, measuring the results." },
          ],
        },
      },
    },
  },
  fr: {
    meta: {
      title: "Logiciels sur mesure et agents IA — XS Consulting",
      description: "XS Consulting construit des équipes d'employés IA, des logiciels de gestion sur mesure et de la conception d'installations pour des entreprises en Suisse et dans le monde. Écrivez-nous sur WhatsApp.",
    },
    common: {
      waDefault: "Bonjour XS Consulting ! J'aimerais plus d'informations.",
      welcome: "Bon retour chez XS Consulting. Si vous le souhaitez, je vous guide moi-même : ouvrez l'assistant en bas à droite et je vous montrerai ce que nous pouvons construire pour votre entreprise.",
      welcomeCta: "Écouter le message de bienvenue",
    },
    nav: {
      links: [
        { href: "#servizi", id: "servizi", label: "Services" },
        { href: "#agenti", id: "agenti", label: "Agents IA" },
        { href: "#progetti", id: "progetti", label: "Projets" },
        { href: "#academy", id: "academy", label: "Academy" },
        { href: "#metodo", id: "metodo", label: "Méthode" },
        { href: "/blog", id: "blog", label: "Blog" },
      ],
      whatsapp: "WhatsApp",
      demo: "Réserver une démo",
    },
    hero: {
      overline: "Nous concevons votre avenir d'entreprise",
      h1Plain: "Agents IA et logiciels de gestion sur mesure pour les PME en Suisse",
      h1a: ["Agents", "IA", "et"],
      h1neon: ["logiciels", "de", "gestion", "sur", "mesure"],
      h1b: ["pour", "les", "PME", "en", "Suisse"],
      subtitle:
        "Nous construisons la première équipe d'employés IA pour votre entreprise. Nos agents IA travaillent aux côtés de votre équipe, automatisent les processus et collaborent entre eux 24h/24. Des solutions sur mesure, pas des forfaits standard.",
      whatsapp: "Écrivez-nous sur WhatsApp",
      whatsappMessage: "Bonjour XS Consulting ! J'aimerais plus d'informations sur votre équipe d'agents IA.",
      demo: "Réserver une démo gratuite",
      claim: "Plus de 50 entreprises ont déjà transformé leur activité avec nous.",
    },
    marquee: {
      label: "Nous nous intégrons aux outils que vous utilisez chaque jour",
    },
    cookies: {
      title: "Cookies et confidentialité",
      text: "Nous utilisons des cookies techniques et, avec votre consentement, des outils d'analyse pour améliorer le site.",
      accept: "Accepter",
      reject: "Refuser",
    },
    expertise: {
      overline: "Ce que nous faisons",
      titleA: "Des solutions sur mesure,",
      titleNeon: "pas des forfaits standard",
      subtitle:
        "Trois âmes, une seule méthode : un logiciel de gestion construit sur vos processus, une conception d'installations confiée à de vrais professionnels et l'automatisation pour les vendeurs sur marketplaces. En ligne, où que vous soyez.",
      cards: {
        gestionale: {
          chip: "Logiciel",
          title: "Logiciels de gestion sur mesure",
          desc: "Nous n'adaptons pas votre entreprise à un logiciel : nous construisons le logiciel autour de votre entreprise. ERP, CRM et plateformes opérationnelles conçues sur vos processus.",
          bullets: [
            "ERP et CRM construits sur vos flux",
            "Automatisation des commandes, du stockage et de la facturation",
            "Tableau de bord de direction avec données en temps réel",
            "Intégration avec les outils que vous utilisez déjà",
          ],
        },
        impianti: {
          chip: "Ingénierie",
          title: "Conception d'installations",
          desc: "De vrais professionnels de la conception d'installations : du relevé au dimensionnement, jusqu'à la documentation technique d'exécution.",
          bullets: [
            "Relevé et analyse des besoins",
            "Dimensionnement et schémas d'exécution",
            "Documentation technique complète",
            "Coordination numérique des chantiers",
          ],
        },
        marketplace: {
          chip: "E-commerce",
          title: "Automatisation Marketplace",
          desc: "Vous vendez sur Amazon, eBay ou Zalando ? Nous automatisons les tâches répétitives, pour que vous puissiez vous concentrer sur la croissance.",
          bullets: [
            "Catalogue et prix synchronisés sur plusieurs marketplaces",
            "Stocks alignés en temps réel",
            "Repricing intelligent et commandes automatiques",
            "Support client avec IA",
          ],
        },
      },
      cta: "Découvrir le service",
    },
    agents: {
      overline: "Nos agents IA",
      titleA: "Une équipe complète d'",
      titleNeon: "agents IA",
      subtitle:
        "Chaque agent est spécialisé. Connectés au cerveau central, ils collaborent entre eux 24 heures sur 24. Ensemble, ils sont imbattables.",
      list: [
        { id: "sales", name: "Sales Agent", desc: "Analyse les clients, envoie des emails personnalisés, gère les relances et conclut les ventes.", tags: ["Recherche de leads", "Email & LinkedIn", "Devis automatiques"] },
        { id: "marketing", name: "Marketing Agent", desc: "Crée des campagnes, gère les contenus et analyse la performance.", tags: ["Création de contenu", "Email marketing", "Analyse ROI"] },
        { id: "operations", name: "Operations Agent", desc: "Gère les processus, tâches, tickets, documents et flux opérationnels.", tags: ["Gestion des tâches", "Système de tickets", "Rapports"] },
        { id: "finance", name: "Finance Agent", desc: "S'occupe des factures, paiements, relances et analyses financières en temps réel.", tags: ["Facturation", "Relances automatiques", "Cash flow"] },
        { id: "hr", name: "HR Agent", desc: "Trouve des talents, gère les entretiens, l'onboarding et la formation du personnel.", tags: ["Tri de CV", "Entretiens IA", "Onboarding"] },
        { id: "executive", name: "Executive Agent", desc: "Votre assistant opérationnel. Vous informe, vous alerte et vous aide à prendre des décisions.", tags: ["Rapports quotidiens", "Alertes intelligentes", "Planification"] },
      ],
    },
    xos: {
      overline: "X OS — Le système d'exploitation de votre entreprise",
      demoBadge: "Exemple de démonstration",
      titleA: "Tout sous contrôle.",
      titleNeon: "Toujours.",
      subtitle:
        "Le tableau de bord X OS vous montre en temps réel ce que font vos agents IA et quels résultats ils génèrent.",
      features: [
        { id: "visibilita", text: "Visibilité complète" },
        { id: "dati", text: "Données en temps réel" },
        { id: "decisioni", text: "Décisions plus rapides" },
        { id: "risultati", text: "Résultats mesurables" },
      ],
      overview: "Aperçu",
      today: "Aujourd'hui",
      goalsTitle: "Objectifs mensuels",
      stats: [
        { id: "agenti", label: "Agents actifs", value: "12", delta: "+2 par rapport à hier" },
        { id: "attivita", label: "Activités terminées", value: "156", delta: "+12%" },
        { id: "lead", label: "Leads générés", value: "32", delta: "+8%" },
        { id: "preventivi", label: "Devis envoyés", value: "5", delta: "+15%" },
      ],
      goals: [
        { label: "Chiffre d'affaires", pct: 78, note: "" },
        { label: "Leads générés", pct: 61, note: "305 / 500" },
        { label: "Nouveaux clients", pct: 80, note: "40 / 50" },
      ],
    },
    projects: {
      overline: "Projets",
      titleA: "Nos réalisations,",
      titleNeon: "présentées",
      subtitle: "Chaque projet a son histoire. Ouvrez les présentations pour découvrir comment nous les avons construits.",
      loading: "Chargement des projets...",
      empty: "Nouveaux projets bientôt disponibles. Écrivez-nous sur WhatsApp pour voir nos études de cas.",
      open: "Lire la présentation",
      close: "Fermer la présentation",
    },
    method: {
      overline: "Comment ça marche",
      titleA: "Notre méthode en",
      titleNeon: "5 étapes",
      steps: [
        { n: "01", title: "Nous analysons", desc: "Nous analysons vos processus et identifions les domaines à plus fort potentiel." },
        { n: "02", title: "Nous concevons", desc: "Nous concevons la stratégie et définissons les agents IA dont vous avez besoin." },
        { n: "03", title: "Nous construisons", desc: "Nous développons et formons des agents IA sur mesure pour votre entreprise." },
        { n: "04", title: "Nous intégrons", desc: "Nous intégrons les agents IA dans vos outils et flux opérationnels." },
        { n: "05", title: "Nous optimisons", desc: "Nous surveillons les performances et améliorons constamment les résultats." },
      ],
    },
    cta: {
      titleA: "Prêt à construire votre",
      titleNeon: "équipe d'employés IA ?",
      subtitle: "Réservez une consultation gratuite avec nos experts et découvrez comment nous pouvons transformer votre entreprise.",
      bullets: ["Consultation gratuite sans engagement", "Solutions sur mesure pour votre activité", "Résultats mesurables, suivis mois par mois"],
      whatsapp: "Écrivez-nous sur WhatsApp",
      whatsappMessage: "Bonjour XS Consulting ! Je souhaite réserver une consultation gratuite.",
      demo: "Réserver la démo",
    },
    footer: {
      tagline: "La première équipe d'employés IA pour votre entreprise. Logiciels de gestion sur mesure, conception d'installations et agents IA — en ligne, partout.",
      explore: "Explorer",
      contacts: "Contact",
      rights: "© XSALES CONSULTING LTD — Tous droits réservés",
      whatsappLabel: "WhatsApp: +41 78 204 21 72",
      legalSeat: "Siège social",
      opSeat: "Siège opérationnel Suisse",
    },
    assistant: {
      name: "Assistant XS",
      status: "Toujours actif",
      steps: [
        "Bonjour ! Je suis l'assistant de XS Consulting. De quoi avez-vous besoin ?",
        "Parfait, {topic}. Comment vous appelez-vous ?",
        "Merci {name} ! Décrivez-moi brièvement votre besoin.",
        "Tout est prêt ! Ouvrez WhatsApp et le message est déjà rédigé pour vous.",
      ],
      topics: [
        { id: "gestionale", label: "Logiciel de gestion sur mesure" },
        { id: "impianti", label: "Conception d'installations" },
        { id: "agenti", label: "Agents IA pour mon entreprise" },
        { id: "altro", label: "Autre" },
      ],
      namePlaceholder: "Votre nom",
      luogoPlaceholder: "Ex. Genève, Suisse",
      aziendaPlaceholder: "Nom de l'entreprise",
      contattoPlaceholder: "Email ou téléphone",
      messagePlaceholder: "Écrivez ici...",
      questions: {
        name: "Comment vous appelez-vous ?",
        luogo: "Où se trouve votre entreprise ? (ville/pays)",
        azienda: "Comment s'appelle votre entreprise ?",
        settore: "Dans quel secteur évoluez-vous ?",
        contatto: "Comment vous joindre ? (email ou téléphone)",
        message: "Merci {name} ! Décrivez-moi brièvement votre besoin.",
      },
      settoreOptions: [
        { id: "industria", label: "Industrie / Manufacture" },
        { id: "commercio", label: "Commerce / E-commerce" },
        { id: "servizi", label: "Services" },
        { id: "impianti", label: "Installations / Construction" },
        { id: "altro", label: "Autre" },
      ],
      open: "Ouvrir WhatsApp",
      restart: "Recommencer",
      direct: "Ou écrivez-nous directement sur WhatsApp →",
      waMessage: "Bonjour XS Consulting ! Je suis {name}. Entreprise : {azienda} ({settore}) — {luogo}. Contact : {contatto}. Je suis intéressé par : {topic}. {message}",
      privacyNote: "En continuant, vous acceptez notre",
      freePlaceholder: "Posez une question libre...",
      or: "ou",
      thinking: "J'écris...",
      continueWhatsApp: "Continuer la conversation sur WhatsApp →",
      backToGuided: "← Retour au guide",
      chatError: "Erreur de connexion. Réessayez ou écrivez-nous sur WhatsApp.",
    },
    demo: {
      overline: "Démo gratuite",
      title: "Réservez votre consultation",
      namePh: "Nom et prénom",
      emailPh: "Email",
      companyPh: "Entreprise",
      messagePh: "De quoi avez-vous besoin ?",
      sending: "Envoi...",
      send: "Envoyer la demande",
      success: "Demande envoyée ! Nous vous recontactons bientôt.",
      error: "Erreur lors de l'envoi. Réessayez ou écrivez-nous sur WhatsApp.",
      privacy: "J'ai lu et j'accepte la",
    },
    academy: {
      overline: "XS Academy",
      titleA: "L'IA pour les entrepreneurs,",
      titleNeon: "expliquée en 10 leçons",
      subtitle: "Un cours pratique pour dirigeants et managers de PME : pas de théorie inutile, seulement des outils utilisables dès le lendemain dans votre entreprise.",
      bullets: [
        "10 leçons en ligne, à suivre quand vous voulez",
        "Des cas réels de ventes, marketing, administration et opérations",
        "Prompts et modèles prêts à copier",
        "Accès à la communauté et aux sessions de questions-réponses",
      ],
      ctaPrimary: "Découvrir le cours",
      ctaSecondary: "Demander des infos sur WhatsApp",
      waMessage: "Bonjour ! J'aimerais des informations sur le cours d'IA pour entrepreneurs.",
      lessonsLabel: "10 leçons en ligne · quand vous voulez",
    },
    academyPage: {
      back: "Retour à l'accueil",
      metaTitle: "XS Academy — L'IA pour les entrepreneurs en 10 leçons",
      programOverline: "Le programme",
      programTitle: "Les 10 leçons",
      programSubtitle: "Un parcours complet : des bases de l'IA aux outils concrets pour les ventes, le marketing, l'administration et les opérations.",
      lessonLabel: "Leçon",
      lessons: [
        { title: "Ce qu'est vraiment un agent IA (et ce qu'il n'est pas)", desc: "Comprenez la différence entre chatbot, automatisation et agent IA, et ce qu'il peut faire aujourd'hui pour votre entreprise." },
        { title: "Radiographie de l'entreprise : cartographier les processus", desc: "Apprenez à identifier les tâches répétitives de chaque service et combien de temps elles vous coûtent chaque semaine." },
        { title: "Évaluer les secteurs : où l'IA rapporte le plus", desc: "Avec une matrice simple, découvrez quels processus offrent le maximum de résultats avec un minimum d'effort." },
        { title: "Analyse des risques avant de démarrer", desc: "Évaluez données, confidentialité et réglementations (RGPD, LPD, AI Act) pour lancer l'IA en toute sécurité et sans surprises." },
        { title: "Business case et ROI", desc: "Calculez coûts, économies et délais de rentabilité pour décider avec des chiffres concrets, pas des impressions." },
        { title: "Choisir outils et partenaires", desc: "Apprenez à vous orienter entre solutions prêtes, no-code et sur mesure, et quelles questions poser aux fournisseurs." },
        { title: "Concevoir le premier agent (le pilote)", desc: "Définissez ce que fait votre premier agent, avec quelles données, quelles limites, et quand une personne intervient." },
        { title: "Lancement du pilote : 30 jours sous contrôle", desc: "Lancez le projet en petit et mesurez les résultats semaine après semaine avec des KPI clairs." },
        { title: "Les personnes : formation et conduite du changement", desc: "Impliquez et formez votre équipe pour transformer l'IA en alliée, pas en menace." },
        { title: "Évaluer, corriger et passer à l'échelle", desc: "Analysez les résultats du pilote et construisez la feuille de route à 12 mois pour étendre l'IA à toute l'entreprise." },
      ],
      ctaOverline: "Cours gratuit",
      ctaTitle: "Recevez les 10 leçons gratuites par email",
      ctaText: "Laissez votre email : nous vous envoyons immédiatement les 10 leçons, gratuitement. Pas de spam, juste le cours.",
      emailPh: "Votre email",
      submit: "Recevoir les 10 leçons gratuites",
      sending: "Envoi en cours...",
      success: "C'est fait ! Vérifiez votre boîte mail : les 10 leçons arrivent.",
      error: "Erreur lors de l'envoi. Réessayez ou écrivez-nous sur WhatsApp.",
      privacyNote: "En continuant, vous acceptez notre",
    },
    seo: {
      gestionale: { title: "Logiciels de gestion sur mesure pour PME en Suisse | XS Consulting", desc: "ERP, CRM et logiciels de gestion construits sur les processus de votre entreprise. Commandes, stock et facturation automatisés. Consultation gratuite." },
      impianti: { title: "Conception d'installations : du relevé à la documentation | XS Consulting", desc: "Conception et dimensionnement d'installations avec des professionnels spécialisés, du relevé à la documentation technique d'exécution." },
      marketplace: { title: "Automatisation Amazon, eBay et Zalando pour vendeurs | XS Consulting", desc: "Catalogue, prix, stock et commandes synchronisés sur toutes les marketplaces. Repricing intelligent et support client avec IA." },
      academy: { title: "Cours IA pour entrepreneurs et PME en 10 leçons | XS Academy", desc: "Cours en ligne pratique pour dirigeants et managers : comment utiliser l'IA dans les ventes, le marketing et l'administration, et comment lancer un agent IA en entreprise." },
      blog: { title: "Blog — Guides et analyses IA | XS Consulting", desc: "Guides pratiques sur les agents IA, les logiciels de gestion sur mesure et l'automatisation pour les PME : cas réels, outils et stratégies." },
    },
    agentsService: {
      chip: "Agents IA",
      h1: "Agents IA sur mesure pour les PME",
      subtitle: "Une équipe d'agents IA qui travaille 24h/24 aux côtés de la vôtre : ventes, administration et support client avancent même quand vous êtes hors ligne.",
      metaTitle: "Agents IA pour PME : automatisez ventes, administration et clients | XS Consulting",
      metaDesc: "Agents IA sur mesure qui travaillent 24h/24 avec votre équipe : devis, relances, support client, factures et rapports. Consultation gratuite.",
      waMessage: "Bonjour XS Consulting ! J'aimerais une consultation gratuite sur les agents IA pour mon entreprise.",
      problemaTitle: "Le problème",
      problemaText: "Chaque semaine, votre entreprise perd des heures dans des tâches répétitives : devis à rédiger, clients à relancer, factures à réclamer, rapports à compiler. Des heures volées à la vente et à la croissance.",
      soluzioneTitle: "La solution",
      soluzioneText: "Une équipe d'agents IA sur mesure, connectés aux outils que vous utilisez déjà — logiciel de gestion, email, WhatsApp, e-commerce. Ils travaillent 24 heures sur 24, suivent vos processus et passent la main à une personne quand il le faut.",
      automationsTitle: "Ce qu'ils automatisent",
      automations: [
        { title: "Devis", desc: "Générés et envoyés automatiquement à partir des données de la demande du client." },
        { title: "Relances", desc: "Relances programmées par email et WhatsApp : aucun client oublié." },
        { title: "Support client", desc: "Réponses immédiates sur WhatsApp et email, 24 heures sur 24." },
        { title: "Factures et rappels", desc: "Émission des factures, rappels de paiement et relances automatiques." },
        { title: "Commandes", desc: "De la commande à la confirmation : mises à jour de statut sans intervention manuelle." },
        { title: "Rapports", desc: "Rapports de ventes et de performance prêts chaque jour dans votre tableau de bord." },
      ],
      agentsTitle: "Les 6 agents de votre équipe",
      integrationsTitle: "Intégrations",
      integrationsText: "Les agents se connectent aux outils que vous utilisez déjà : ERP et logiciels de gestion, CRM, email, WhatsApp Business, e-commerce et marketplaces, comptabilité. Aucune révolution : ils s'intègrent à vos processus.",
      faqTitle: "Questions fréquentes",
      faq: [
        { q: "Combien ça coûte ?", a: "Cela dépend du nombre d'agents et des intégrations. La consultation initiale est gratuite : nous analysons vos processus et vous recevez un devis clair avant de commencer." },
        { q: "En combien de temps est-ce opérationnel ?", a: "Le premier agent pilote est généralement opérationnel en 2 à 4 semaines, avec des résultats mesurés dès les 30 premiers jours." },
        { q: "Dois-je changer de logiciel ?", a: "Non. Les agents se connectent aux outils que vous utilisez déjà : logiciel de gestion, email, WhatsApp, e-commerce. S'il manque quelque chose, nous le construisons sur mesure." },
        { q: "Mes données sont-elles en sécurité ?", a: "Oui : nous travaillons dans le respect du RGPD, du UK GDPR et de la nLPD, avec des accès contrôlés et des connexions chiffrées. Vos données restent les vôtres." },
        { q: "Puis-je commencer avec un seul agent ?", a: "Bien sûr. On démarre avec un pilote sur un seul processus, on mesure les résultats, puis on étend au reste de l'entreprise." },
      ],
      ctaOverline: "Parlons-en",
      ctaTitle: "Prêt à automatiser votre entreprise ?",
      ctaText: "Réservez une consultation gratuite : nous analysons vos processus ensemble et vous montrons où un agent IA rapporte le plus.",
    },
    contatti: {
      metaTitle: "Contact — XS Consulting, Manno (Tessin)",
      metaDesc: "Contactez XS Consulting : Via Cantonale 38, 6928 Manno TI, Suisse. Tél. et WhatsApp +41 78 204 21 72. Consultation gratuite sur agents IA et logiciels de gestion sur mesure.",
      h1: "Parlons-en",
      subtitle: "Nous sommes à Manno, au Tessin — et en ligne partout. Appelez-nous, écrivez-nous sur WhatsApp ou laissez un message : nous répondons sous 24 heures ouvrées.",
      addressTitle: "Siège opérationnel",
      formTitle: "Écrivez-nous un message",
      namePh: "Nom et prénom",
      emailPh: "Email",
      messagePh: "Comment pouvons-nous vous aider ?",
      submit: "Envoyer le message",
      sending: "Envoi...",
      success: "Message envoyé ! Nous vous recontactons sous 24 heures ouvrées.",
      error: "Erreur lors de l'envoi. Réessayez ou écrivez-nous sur WhatsApp.",
      privacyNote: "En continuant, vous acceptez notre",
      whatsappCta: "Écrivez-nous sur WhatsApp",
      waMessage: "Bonjour XS Consulting ! Je vous contacte depuis le site : j'aimerais plus d'informations.",
    },
    servicePages: {
      back: "Retour à l'accueil",
      perChiTitle: "Pour qui",
      howTitle: "Comment nous travaillons",
      examplesTitle: "Exemples concrets",
      faqTitle: "Questions fréquentes",
      whatOverline: "Ce que nous faisons",
      whyTitle: "Pourquoi nous choisir",
      ctaOverline: "Parlons-en",
      ctaTitle: "Parlez-nous de votre projet",
      ctaText: "Une consultation gratuite pour comprendre ensemble comment automatiser et développer votre entreprise.",
      ctaPrimary: "Réserver une consultation gratuite",
      ctaSecondary: "Parler à l'assistant IA",
      services: {
        gestionale: {
          chip: "Logiciel",
          title: "Logiciels de gestion sur mesure",
          subtitle: "Nous n'adaptons pas votre entreprise à un logiciel : nous construisons le logiciel autour de votre entreprise. ERP, CRM et plateformes opérationnelles conçues sur vos processus.",
          metaTitle: "Logiciels de gestion sur mesure — XS Consulting",
          features: [
            { title: "Analyse des processus", desc: "Nous cartographions vos flux de travail réels avant d'écrire la moindre ligne de code." },
            { title: "ERP et CRM sur mesure", desc: "Clients, commandes, stock et facturation dans un seul outil construit pour vous." },
            { title: "Automatisations opérationnelles", desc: "Nous éliminons les tâches répétitives avec des flux automatiques et des agents IA." },
            { title: "Tableau de bord de direction", desc: "Ventes, stock et performance en temps réel, toujours sous contrôle." },
            { title: "Intégrations", desc: "Nous connectons le logiciel aux outils que vous utilisez déjà : e-commerce, comptabilité, email." },
            { title: "Formation et support", desc: "Nous accompagnons votre équipe après le lancement, avec une assistance continue." },
          ],
          why: "Chaque logiciel est construit sur vos processus et grandit avec votre entreprise : pas de licences inutiles, pas de fonctions que vous n'utiliserez jamais. Et avec nos agents IA intégrés, le logiciel travaille pour vous même quand vous êtes hors ligne.",
          perChi: "Pour les dirigeants et managers de PME en Suisse et au Tessin qui perdent chaque semaine des heures entre fichiers Excel, commandes dispersées et facturation manuelle — et qui veulent un outil unique construit sur leurs processus, pas l'inverse.",
          examples: [
            "Un atelier de la région de Lugano qui gère chantiers, heures et factures dans un tableau de bord unique",
            "Un e-commerce tessinois qui synchronise stock et commandes entre boutique et logiciel de gestion",
            "Un cabinet de services qui automatise devis et rappels de paiement",
          ],
          faq: [
            { q: "Combien coûte un logiciel de gestion sur mesure ?", a: "Cela dépend des modules et des intégrations. Après la consultation gratuite, vous recevez un devis ferme, sans surprises." },
            { q: "Combien de temps faut-il ?", a: "Une première version opérationnelle en général en 4 à 8 semaines, puis une extension module par module." },
            { q: "Puis-je importer les données de mon ancien logiciel ?", a: "Oui, nous migrons les données depuis Excel, CSV et les principaux logiciels utilisés en Suisse." },
            { q: "Est-ce compatible avec la facturation suisse (facture QR) ?", a: "Oui, nous prenons en charge la facture QR et les standards suisses de facturation." },
            { q: "Et si mon processus change ?", a: "Le logiciel est modulaire : il s'adapte et grandit avec votre entreprise, avec une assistance continue de notre équipe au Tessin." },
          ],
        },
        impianti: {
          chip: "Ingénierie",
          title: "Conception d'installations",
          subtitle: "De vrais professionnels de la conception d'installations : du relevé au dimensionnement, jusqu'à la documentation technique d'exécution.",
          metaTitle: "Conception d'installations — XS Consulting",
          features: [
            { title: "Relevé et analyse", desc: "Visite sur site et collecte des exigences techniques, fonctionnelles et réglementaires." },
            { title: "Dimensionnement", desc: "Calculs et choix de conception conformes aux normes en vigueur." },
            { title: "Schémas d'exécution", desc: "Des plans clairs et prêts pour la réalisation." },
            { title: "Documentation technique", desc: "Rapports, cahiers des charges et dossiers complets, toujours en ordre." },
            { title: "Coordination numérique", desc: "Chantiers, révisions et livraisons gérés dans un flux numérique unique." },
            { title: "Support sur chantier", desc: "Assistance pendant la réalisation et la réception finale." },
          ],
          why: "Nous unissons l'expérience de professionnels de la conception à la rapidité des outils numériques : délais certains, documents toujours en ordre et un interlocuteur unique pour tout le projet.",
          perChi: "Pour les entreprises de construction, installateurs et bureaux d'études au Tessin et en Suisse qui ont besoin de projets conformes, d'une documentation en ordre et de délais certains.",
          examples: [
            "Conception des installations électriques d'une nouvelle résidence à Manno",
            "Dimensionnement et schémas d'exécution pour la rénovation d'un bâtiment commercial à Lugano",
            "Documentation technique et coordination numérique pour un projet multi-installations",
          ],
          faq: [
            { q: "Travaillez-vous dans toute la Suisse ?", a: "Nous sommes au Tessin et intervenons sur tout le territoire suisse, avec des relevés sur place sur rendez-vous." },
            { q: "Connaissez-vous les normes suisses (NIN, SIA) ?", a: "Oui, nos projets suivent les normes en vigueur en Suisse et la documentation est complète pour les autorités compétentes." },
            { q: "Pouvez-vous partir d'un relevé existant ?", a: "Oui : nous pouvons valider un relevé existant ou en réaliser un nouveau sur place." },
            { q: "Combien de temps prend une conception ?", a: "Cela dépend de l'ampleur du projet : après une première analyse, nous vous donnons un calendrier clair et engagé." },
            { q: "Faites-vous aussi la direction des travaux ?", a: "Sur demande, nous accompagnons la phase de réalisation et la réception finale." },
          ],
        },
        marketplace: {
          chip: "E-commerce",
          title: "Automatisation pour les vendeurs Marketplace",
          subtitle: "Vous vendez sur Amazon, eBay ou Zalando ? Nous automatisons les tâches répétitives, pour que vous puissiez vous concentrer sur la croissance.",
          metaTitle: "Automatisation Marketplace — XS Consulting",
          features: [
            { title: "Gestion du catalogue", desc: "Chargement et mise à jour des produits, prix et descriptions sur plusieurs marketplaces à la fois." },
            { title: "Synchronisation des stocks", desc: "Stocks alignés en temps réel : fini les ventes de produits épuisés." },
            { title: "Commandes et expéditions", desc: "Flux automatique de la commande à l'étiquette d'expédition." },
            { title: "Repricing intelligent", desc: "Des prix adaptés à la concurrence selon vos règles." },
            { title: "Support client avec IA", desc: "Réponses automatiques aux questions fréquentes et aux messages des acheteurs." },
            { title: "Rapports et analyses", desc: "Ventes, marges et performances dans un tableau de bord unique." },
          ],
          why: "Nous connectons les marketplaces à votre logiciel de gestion et à vos outils, avec des agents IA sur mesure pour votre activité.",
          perChi: "Pour les vendeurs et marques en Suisse et en Italie qui vendent sur Amazon, eBay ou Zalando et passent trop d'heures sur les catalogues, les prix et les expéditions.",
          examples: [
            "Un vendeur tessinois qui a réduit de 90 % les erreurs de stock entre Amazon et son logiciel de gestion",
            "Une marque qui met à jour 2 000 prix par jour avec des règles de repricing automatiques",
            "Un e-commerce qui répond à ses clients en 3 langues avec un agent IA",
          ],
          faq: [
            { q: "Avec quelles marketplaces travaillez-vous ?", a: "Amazon, eBay, Zalando et d'autres sur demande, toutes connectées à votre logiciel de gestion." },
            { q: "Dois-je changer de logiciel de gestion ?", a: "Non : nous nous connectons à ce que vous utilisez déjà. S'il manque quelque chose, nous construisons le pont." },
            { q: "Le repricing peut-il descendre sous ma marge ?", a: "Non : vous définissez les règles, avec des prix minimum et maximum infranchissables." },
            { q: "En combien de temps est-ce actif ?", a: "Les premières synchronisations sont généralement actives en 2 à 4 semaines." },
            { q: "Puis-je commencer avec une seule marketplace ?", a: "Oui, puis nous ajoutons les autres une à la fois, en mesurant les résultats." },
          ],
        },
      },
    },
  },
  de: {
    meta: {
      title: "Maßgeschneiderte Software & KI-Agenten — XS Consulting",
      description: "XS Consulting baut Teams digitaler KI-Mitarbeiter, maßgeschneiderte Verwaltungssoftware und Anlagenplanung für Unternehmen in der Schweiz und weltweit. Schreiben Sie uns auf WhatsApp.",
    },
    common: {
      waDefault: "Hallo XS Consulting! Ich hätte gerne mehr Informationen.",
      welcome: "Willkommen zurück bei XS Consulting. Ich führe Sie gerne selbst: Öffnen Sie den Assistenten unten rechts und ich zeige Ihnen, was wir für Ihr Unternehmen bauen können.",
      welcomeCta: "Sprachnachricht anhören",
    },
    nav: {
      links: [
        { href: "#servizi", id: "servizi", label: "Leistungen" },
        { href: "#agenti", id: "agenti", label: "KI-Agenten" },
        { href: "#progetti", id: "progetti", label: "Projekte" },
        { href: "#academy", id: "academy", label: "Academy" },
        { href: "#metodo", id: "metodo", label: "Methode" },
        { href: "/blog", id: "blog", label: "Blog" },
      ],
      whatsapp: "WhatsApp",
      demo: "Demo buchen",
    },
    hero: {
      overline: "Wir gestalten Ihre Unternehmenszukunft",
      h1Plain: "KI-Agenten und maßgeschneiderte Verwaltungssoftware für KMU in der Schweiz",
      h1a: ["KI-Agenten", "und"],
      h1neon: ["maßgeschneiderte", "Verwaltungssoftware"],
      h1b: ["für", "KMU", "in", "der", "Schweiz"],
      subtitle:
        "Wir bauen das erste Team digitaler KI-Mitarbeiter für Ihr Unternehmen. Unsere KI-Agenten arbeiten Seite an Seite mit Ihrem Team, automatisieren Prozesse und arbeiten 24 Stunden am Tag zusammen. Maßgeschneiderte Lösungen, keine Standardpakete.",
      whatsapp: "Schreiben Sie uns auf WhatsApp",
      whatsappMessage: "Hallo XS Consulting! Ich hätte gerne mehr Informationen über Ihr KI-Agenten-Team.",
      demo: "Kostenlose Demo buchen",
      claim: "Über 50 Unternehmen haben ihr Geschäft bereits mit uns transformiert.",
    },
    marquee: {
      label: "Wir integrieren uns in die Tools, die Sie täglich nutzen",
    },
    cookies: {
      title: "Cookies & Datenschutz",
      text: "Wir verwenden technische Cookies und, mit Ihrer Einwilligung, Analyse-Tools zur Verbesserung der Website.",
      accept: "Akzeptieren",
      reject: "Ablehnen",
    },
    expertise: {
      overline: "Was wir tun",
      titleA: "Maßgeschneiderte Lösungen,",
      titleNeon: "keine Standardpakete",
      subtitle:
        "Drei Seelen, eine Methode: Verwaltungssoftware, die auf Ihre Prozesse zugeschnitten ist, Anlagenplanung durch echte Profis und Automatisierung für Marketplace-Verkäufer. Online, wo immer Sie sind.",
      cards: {
        gestionale: {
          chip: "Software",
          title: "Maßgeschneiderte Verwaltungssoftware",
          desc: "Wir passen Ihr Unternehmen nicht an eine Software an: Wir bauen die Software um Ihr Unternehmen herum. ERP, CRM und operative Plattformen, zugeschnitten auf Ihre Prozesse.",
          bullets: [
            "ERP und CRM auf Basis Ihrer Abläufe",
            "Automatisierung von Bestellungen, Lager und Fakturierung",
            "Management-Dashboard mit Echtzeitdaten",
            "Integration mit den Tools, die Sie bereits nutzen",
          ],
        },
        impianti: {
          chip: "Ingenieurwesen",
          title: "Anlagenplanung",
          desc: "Echte Profis der Anlagenplanung: von der Aufnahme über die Dimensionierung bis zur technischen Ausführungsdokumentation.",
          bullets: [
            "Aufnahme und Bedarfsanalyse",
            "Dimensionierung und Ausführungsschemata",
            "Vollständige technische Dokumentation",
            "Digitale Auftragskoordination",
          ],
        },
        marketplace: {
          chip: "E-Commerce",
          title: "Marketplace-Automatisierung",
          desc: "Sie verkaufen auf Amazon, eBay oder Zalando? Wir automatisieren die wiederkehrenden Aufgaben, damit Sie sich auf das Wachstum konzentrieren.",
          bullets: [
            "Katalog und Preise auf mehreren Marktplätzen synchronisiert",
            "Lagerbestände in Echtzeit abgeglichen",
            "Intelligentes Repricing und automatische Bestellungen",
            "Kundenbetreuung mit KI",
          ],
        },
      },
      cta: "Service entdecken",
    },
    agents: {
      overline: "Unsere KI-Agenten",
      titleA: "Ein komplettes Team von",
      titleNeon: "KI-Agenten",
      subtitle:
        "Jeder Agent ist spezialisiert. Mit dem zentralen Gehirn verbunden, arbeiten sie 24 Stunden am Tag zusammen. Zusammen sind sie unschlagbar.",
      list: [
        { id: "sales", name: "Sales Agent", desc: "Analysiert Kunden, versendet personalisierte E-Mails, verwaltet Follow-ups und schließt Verkäufe ab.", tags: ["Lead-Recherche", "E-Mail & LinkedIn", "Automatische Angebote"] },
        { id: "marketing", name: "Marketing Agent", desc: "Erstellt Kampagnen, verwaltet Inhalte und analysiert die Performance.", tags: ["Content-Erstellung", "E-Mail-Marketing", "ROI-Analyse"] },
        { id: "operations", name: "Operations Agent", desc: "Verwaltet Prozesse, Aufgaben, Tickets, Dokumente und operative Abläufe.", tags: ["Aufgabenverwaltung", "Ticketsystem", "Berichte"] },
        { id: "finance", name: "Finance Agent", desc: "Kümmert sich um Rechnungen, Zahlungen, Mahnungen und Finanzanalysen in Echtzeit.", tags: ["Fakturierung", "Automatische Mahnungen", "Cashflow"] },
        { id: "hr", name: "HR Agent", desc: "Findet Talente, verwaltet Bewerbungsgespräche, Onboarding und Mitarbeiterschulungen.", tags: ["CV-Screening", "KI-Gespräche", "Onboarding"] },
        { id: "executive", name: "Executive Agent", desc: "Ihr operativer Assistent. Hält Sie auf dem Laufenden, warnt Sie und hilft bei Entscheidungen.", tags: ["Tägliche Berichte", "Intelligente Alerts", "Planung"] },
      ],
    },
    xos: {
      overline: "X OS — Das Betriebssystem Ihres Unternehmens",
      demoBadge: "Demonstrationsbeispiel",
      titleA: "Alles unter Kontrolle.",
      titleNeon: "Immer.",
      subtitle:
        "Das X-OS-Dashboard zeigt Ihnen in Echtzeit, was Ihre KI-Agenten tun und welche Ergebnisse sie erzielen.",
      features: [
        { id: "visibilita", text: "Volle Transparenz" },
        { id: "dati", text: "Echtzeitdaten" },
        { id: "decisioni", text: "Schnellere Entscheidungen" },
        { id: "risultati", text: "Messbare Ergebnisse" },
      ],
      overview: "Übersicht",
      today: "Heute",
      goalsTitle: "Monatsziele",
      stats: [
        { id: "agenti", label: "Aktive Agenten", value: "12", delta: "+2 gegenüber gestern" },
        { id: "attivita", label: "Abgeschlossene Aktivitäten", value: "156", delta: "+12%" },
        { id: "lead", label: "Generierte Leads", value: "32", delta: "+8%" },
        { id: "preventivi", label: "Versendete Angebote", value: "5", delta: "+15%" },
      ],
      goals: [
        { label: "Umsatz", pct: 78, note: "" },
        { label: "Generierte Leads", pct: 61, note: "305 / 500" },
        { label: "Neue Kunden", pct: 80, note: "40 / 50" },
      ],
    },
    projects: {
      overline: "Projekte",
      titleA: "Unsere Arbeiten,",
      titleNeon: "präsentiert",
      subtitle: "Jedes Projekt hat seine Geschichte. Öffnen Sie die Präsentationen, um zu sehen, wie wir sie umgesetzt haben.",
      loading: "Projekte werden geladen...",
      empty: "Neue Projekte folgen in Kürze. Schreiben Sie uns auf WhatsApp, um unsere Fallstudien zu sehen.",
      open: "Präsentation lesen",
      close: "Präsentation schließen",
    },
    method: {
      overline: "So funktioniert es",
      titleA: "Unsere Methode in",
      titleNeon: "5 Schritten",
      steps: [
        { n: "01", title: "Wir analysieren", desc: "Wir analysieren Ihre Prozesse und identifizieren die Bereiche mit dem größten Potenzial." },
        { n: "02", title: "Wir planen", desc: "Wir entwerfen die Strategie und definieren die KI-Agenten, die Sie benötigen." },
        { n: "03", title: "Wir bauen", desc: "Wir entwickeln und trainieren KI-Agenten, maßgeschneidert für Ihr Unternehmen." },
        { n: "04", title: "Wir integrieren", desc: "Wir integrieren KI-Agenten in Ihre Tools und operativen Abläufe." },
        { n: "05", title: "Wir optimieren", desc: "Wir überwachen die Performance und verbessern die Ergebnisse kontinuierlich." },
      ],
    },
    cta: {
      titleA: "Bereit, Ihr Team von",
      titleNeon: "KI-Mitarbeitern aufzubauen?",
      subtitle: "Buchen Sie eine kostenlose Beratung mit unseren Experten und entdecken Sie, wie wir Ihr Unternehmen transformieren können.",
      bullets: ["Kostenlose Beratung ohne Verpflichtung", "Maßgeschneiderte Lösungen für Ihr Geschäft", "Messbare Ergebnisse, Monat für Monat überwacht"],
      whatsapp: "Schreiben Sie uns auf WhatsApp",
      whatsappMessage: "Hallo XS Consulting! Ich möchte eine kostenlose Beratung buchen.",
      demo: "Jetzt Demo buchen",
    },
    footer: {
      tagline: "Das erste Team digitaler KI-Mitarbeiter für Ihr Unternehmen. Maßgeschneiderte Verwaltungssoftware, Anlagenplanung und KI-Agenten — online, überall.",
      explore: "Entdecken",
      contacts: "Kontakt",
      rights: "© XSALES CONSULTING LTD — Alle Rechte vorbehalten",
      whatsappLabel: "WhatsApp: +41 78 204 21 72",
      legalSeat: "Rechtlicher Sitz",
      opSeat: "Operativer Sitz Schweiz",
    },
    assistant: {
      name: "XS Assistent",
      status: "Immer aktiv",
      steps: [
        "Hallo! Ich bin der Assistent von XS Consulting. Womit kann ich helfen?",
        "Perfekt, {topic}. Wie heißen Sie?",
        "Danke, {name}! Beschreiben Sie mir kurz Ihr Anliegen.",
        "Alles bereit! Öffnen Sie WhatsApp und Ihre Nachricht ist bereits vorbereitet.",
      ],
      topics: [
        { id: "gestionale", label: "Maßgeschneiderte Software" },
        { id: "impianti", label: "Anlagenplanung" },
        { id: "agenti", label: "KI-Agenten für mein Unternehmen" },
        { id: "altro", label: "Sonstiges" },
      ],
      namePlaceholder: "Ihr Name",
      luogoPlaceholder: "Z.B. Zürich, Schweiz",
      aziendaPlaceholder: "Firmenname",
      contattoPlaceholder: "E-Mail oder Telefon",
      messagePlaceholder: "Hier schreiben...",
      questions: {
        name: "Wie heißen Sie?",
        luogo: "Wo befindet sich Ihr Unternehmen? (Stadt/Land)",
        azienda: "Wie heißt Ihr Unternehmen?",
        settore: "In welcher Branche sind Sie tätig?",
        contatto: "Wie erreichen wir Sie? (E-Mail oder Telefon)",
        message: "Danke, {name}! Beschreiben Sie mir kurz Ihr Anliegen.",
      },
      settoreOptions: [
        { id: "industria", label: "Industrie / Fertigung" },
        { id: "commercio", label: "Handel / E-Commerce" },
        { id: "servizi", label: "Dienstleistungen" },
        { id: "impianti", label: "Anlagen / Bau" },
        { id: "altro", label: "Sonstiges" },
      ],
      open: "WhatsApp öffnen",
      restart: "Neu starten",
      direct: "Oder schreiben Sie uns direkt auf WhatsApp →",
      waMessage: "Hallo XS Consulting! Ich bin {name}. Unternehmen: {azienda} ({settore}) — {luogo}. Kontakt: {contatto}. Ich interessiere mich für: {topic}. {message}",
      privacyNote: "Mit dem Absenden akzeptieren Sie unsere",
      freePlaceholder: "Stellen Sie eine freie Frage...",
      or: "oder",
      thinking: "Schreibe...",
      continueWhatsApp: "Das Gespräch auf WhatsApp fortsetzen →",
      backToGuided: "← Zurück zum Guide",
      chatError: "Verbindungsfehler. Versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
    },
    demo: {
      overline: "Kostenlose Demo",
      title: "Buchen Sie Ihre Beratung",
      namePh: "Vor- und Nachname",
      emailPh: "E-Mail",
      companyPh: "Unternehmen",
      messagePh: "Was benötigen Sie?",
      sending: "Wird gesendet...",
      send: "Anfrage senden",
      success: "Anfrage gesendet! Wir melden uns in Kürze.",
      error: "Fehler beim Senden. Versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
      privacy: "Ich habe die",
    },
    academy: {
      overline: "XS Academy",
      titleA: "KI für Unternehmer,",
      titleNeon: "erklärt in 10 Lektionen",
      subtitle: "Ein praktischer Kurs für Inhaber und Manager von KMU: keine nutzlose Theorie, nur Werkzeuge, die Sie ab dem nächsten Tag in Ihrem Unternehmen einsetzen können.",
      bullets: [
        "10 Online-Lektionen, jederzeit abrufbar",
        "Echte Fälle aus Vertrieb, Marketing, Verwaltung und Operations",
        "Prompts und Vorlagen zum Kopieren",
        "Zugang zur Community und zu Frage-Antwort-Sessions",
      ],
      ctaPrimary: "Kurs entdecken",
      ctaSecondary: "Infos auf WhatsApp anfragen",
      waMessage: "Hallo! Ich hätte gerne Informationen über den KI-Kurs für Unternehmer.",
      lessonsLabel: "10 Online-Lektionen · jederzeit",
    },
    academyPage: {
      back: "Zurück zur Startseite",
      metaTitle: "XS Academy — KI für Unternehmer in 10 Lektionen",
      programOverline: "Das Programm",
      programTitle: "Die 10 Lektionen",
      programSubtitle: "Ein kompletter Weg: von den KI-Grundlagen bis zu konkreten Werkzeugen für Vertrieb, Marketing, Verwaltung und Operations.",
      lessonLabel: "Lektion",
      lessons: [
        { title: "Was ein KI-Agent wirklich ist (und was nicht)", desc: "Verstehen Sie den Unterschied zwischen Chatbot, Automatisierung und KI-Agent – und was er heute für Ihr Unternehmen tun kann." },
        { title: "Röntgenbild des Unternehmens: Prozesse kartieren", desc: "Lernen Sie, die wiederkehrenden Aufgaben jeder Abteilung zu erkennen und wie viel Zeit sie Sie jede Woche kosten." },
        { title: "Bereiche bewerten: Wo sich KI am meisten lohnt", desc: "Mit einer einfachen Matrix entdecken Sie, welche Prozesse das größte Ergebnis bei minimalem Aufwand liefern." },
        { title: "Risikobewertung vor dem Start", desc: "Bewerten Sie Daten, Datenschutz und Vorschriften (DSGVO, DSG, AI Act), um KI sicher und ohne Überraschungen zu starten." },
        { title: "Business Case und ROI", desc: "Berechnen Sie Kosten, Einsparungen und Amortisationszeit, um mit konkreten Zahlen statt Bauchgefühl zu entscheiden." },
        { title: "Tools und Partner auswählen", desc: "Erfahren Sie, wie Sie sich zwischen fertigen, No-Code- und maßgeschneiderten Lösungen orientieren und welche Fragen Sie Anbietern stellen." },
        { title: "Den ersten Agenten entwerfen (der Pilot)", desc: "Definieren Sie, was Ihr erster Agent tut, mit welchen Daten, welchen Grenzen und wann ein Mensch eingreift." },
        { title: "Pilotstart: 30 Tage unter Kontrolle", desc: "Starten Sie das Projekt klein und messen Sie die Ergebnisse Woche für Woche mit klaren KPIs." },
        { title: "Die Menschen: Schulung und Change Management", desc: "Binden Sie Ihr Team ein und schulen Sie es, damit KI zum Verbündeten wird, nicht zur Bedrohung." },
        { title: "Bewerten, korrigieren und skalieren", desc: "Analysieren Sie die Pilotergebnisse und bauen Sie die 12-Monats-Roadmap, um KI auf das ganze Unternehmen auszuweiten." },
      ],
      ctaOverline: "Kostenloser Kurs",
      ctaTitle: "Erhalten Sie die 10 kostenlosen Lektionen per E-Mail",
      ctaText: "Hinterlassen Sie Ihre E-Mail: Wir senden Ihnen sofort alle 10 Lektionen, kostenlos. Kein Spam, nur der Kurs.",
      emailPh: "Ihre E-Mail",
      submit: "Die 10 kostenlosen Lektionen erhalten",
      sending: "Wird gesendet...",
      success: "Fertig! Prüfen Sie Ihr Postfach: Die 10 Lektionen sind unterwegs.",
      error: "Fehler beim Senden. Versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
      privacyNote: "Mit dem Absenden akzeptieren Sie unsere",
    },
    seo: {
      gestionale: { title: "Maßgeschneiderte Verwaltungssoftware für KMU in der Schweiz | XS Consulting", desc: "ERP, CRM und Verwaltungssoftware, aufgebaut auf den Prozessen Ihres Unternehmens. Bestellungen, Lager und Fakturierung automatisiert. Kostenlose Beratung." },
      impianti: { title: "Anlagenplanung: von der Aufnahme bis zur Dokumentation | XS Consulting", desc: "Anlagenplanung und -dimensionierung mit spezialisierten Fachleuten, von der Aufnahme bis zur technischen Ausführungsdokumentation." },
      marketplace: { title: "Amazon-, eBay- und Zalando-Automatisierung für Verkäufer | XS Consulting", desc: "Katalog, Preise, Lager und Bestellungen auf allen Marktplätzen synchronisiert. Intelligentes Repricing und KI-Kundensupport." },
      academy: { title: "KI-Kurs für Unternehmer und KMU in 10 Lektionen | XS Academy", desc: "Praktischer Online-Kurs für Inhaber und Manager: KI in Vertrieb, Marketing und Verwaltung nutzen und einen KI-Agenten im Unternehmen starten." },
      blog: { title: "Blog — KI-Guides und Einblicke | XS Consulting", desc: "Praktische Guides zu KI-Agenten, maßgeschneiderter Verwaltungssoftware und Automatisierung für KMU: echte Fälle, Tools und Strategien." },
    },
    agentsService: {
      chip: "KI-Agenten",
      h1: "Maßgeschneiderte KI-Agenten für KMU",
      subtitle: "Ein Team von KI-Agenten, das rund um die Uhr mit Ihrem Team arbeitet: Vertrieb, Verwaltung und Kundenbetreuung laufen weiter, auch wenn Sie offline sind.",
      metaTitle: "KI-Agenten für KMU: Vertrieb, Verwaltung und Kunden automatisieren | XS Consulting",
      metaDesc: "Maßgeschneiderte KI-Agenten, die rund um die Uhr mit Ihrem Team arbeiten: Angebote, Follow-ups, Kundenbetreuung, Rechnungen und Berichte. Kostenlose Beratung.",
      waMessage: "Hallo XS Consulting! Ich hätte gerne eine kostenlose Beratung zu KI-Agenten für mein Unternehmen.",
      problemaTitle: "Das Problem",
      problemaText: "Jede Woche verliert Ihr Unternehmen Stunden an wiederkehrende Aufgaben: Angebote schreiben, Kunden zurückrufen, Rechnungen mahnen, Berichte erstellen. Stunden, die dem Verkauf und dem Wachstum fehlen.",
      soluzioneTitle: "Die Lösung",
      soluzioneText: "Ein Team maßgeschneiderter KI-Agenten, verbunden mit den Tools, die Sie bereits nutzen — Verwaltungssoftware, E-Mail, WhatsApp, E-Commerce. Sie arbeiten rund um die Uhr, folgen Ihren Prozessen und übergeben an einen Menschen, wenn es nötig ist.",
      automationsTitle: "Was sie automatisieren",
      automations: [
        { title: "Angebote", desc: "Automatisch aus den Anfragedaten des Kunden erstellt und versendet." },
        { title: "Follow-ups", desc: "Geplante Kontakte per E-Mail und WhatsApp: kein Kunde wird vergessen." },
        { title: "Kundenbetreuung", desc: "Sofortige Antworten auf WhatsApp und E-Mail, rund um die Uhr." },
        { title: "Rechnungen & Mahnungen", desc: "Rechnungsstellung, Zahlungserinnerungen und automatische Mahnungen." },
        { title: "Bestellungen", desc: "Von der Bestellung bis zur Bestätigung: Statusaktualisierungen ohne manuellen Aufwand." },
        { title: "Berichte", desc: "Vertriebs- und Performance-Reports jeden Tag fertig in Ihrem Dashboard." },
      ],
      agentsTitle: "Die 6 Agenten Ihres Teams",
      integrationsTitle: "Integrationen",
      integrationsText: "Die Agenten verbinden sich mit den Tools, die Sie bereits nutzen: ERP und Verwaltungssoftware, CRM, E-Mail, WhatsApp Business, E-Commerce und Marktplätze, Buchhaltung. Keine Revolution: Sie fügen sich in Ihre Prozesse ein.",
      faqTitle: "Häufige Fragen",
      faq: [
        { q: "Was kostet das?", a: "Es hängt von der Anzahl der Agenten und Integrationen ab. Die Erstberatung ist kostenlos: Wir analysieren Ihre Prozesse und Sie erhalten ein klares Angebot, bevor es losgeht." },
        { q: "Wie schnell ist es einsatzbereit?", a: "Der erste Pilot-Agent ist typischerweise in 2–4 Wochen einsatzbereit, mit Ergebnismessung schon in den ersten 30 Tagen." },
        { q: "Muss ich die Software wechseln?", a: "Nein. Die Agenten verbinden sich mit den Tools, die Sie bereits nutzen: Verwaltungssoftware, E-Mail, WhatsApp, E-Commerce. Fehlt etwas, bauen wir es maßgeschneidert." },
        { q: "Sind meine Daten sicher?", a: "Ja: Wir arbeiten im Einklang mit DSGVO, UK GDPR und nDSG, mit kontrollierten Zugriffen und verschlüsselten Verbindungen. Ihre Daten bleiben Ihre." },
        { q: "Kann ich mit nur einem Agenten starten?", a: "Natürlich. Sie starten mit einem Piloten für einen einzelnen Prozess, messen die Ergebnisse und skalieren dann auf das ganze Unternehmen." },
      ],
      ctaOverline: "Sprechen wir darüber",
      ctaTitle: "Bereit, Ihr Unternehmen zu automatisieren?",
      ctaText: "Buchen Sie eine kostenlose Beratung: Wir analysieren gemeinsam Ihre Prozesse und zeigen Ihnen, wo sich ein KI-Agent am meisten lohnt.",
    },
    contatti: {
      metaTitle: "Kontakt — XS Consulting, Manno (Tessin)",
      metaDesc: "Kontaktieren Sie XS Consulting: Via Cantonale 38, 6928 Manno TI, Schweiz. Tel. & WhatsApp +41 78 204 21 72. Kostenlose Beratung zu KI-Agenten und maßgeschneiderter Verwaltungssoftware.",
      h1: "Sprechen wir darüber",
      subtitle: "Wir sind in Manno, im Tessin — und online überall. Rufen Sie uns an, schreiben Sie uns auf WhatsApp oder hinterlassen Sie eine Nachricht: Wir antworten innerhalb von 24 Arbeitsstunden.",
      addressTitle: "Operativer Sitz",
      formTitle: "Schreiben Sie uns",
      namePh: "Vor- und Nachname",
      emailPh: "E-Mail",
      messagePh: "Wie können wir Ihnen helfen?",
      submit: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Nachricht gesendet! Wir melden uns innerhalb von 24 Arbeitsstunden.",
      error: "Fehler beim Senden. Versuchen Sie es erneut oder schreiben Sie uns auf WhatsApp.",
      privacyNote: "Mit dem Absenden akzeptieren Sie unsere",
      whatsappCta: "Schreiben Sie uns auf WhatsApp",
      waMessage: "Hallo XS Consulting! Ich schreibe Ihnen von der Website: Ich hätte gerne mehr Informationen.",
    },
    servicePages: {
      back: "Zurück zur Startseite",
      perChiTitle: "Für wen",
      howTitle: "Wie wir arbeiten",
      examplesTitle: "Konkrete Beispiele",
      faqTitle: "Häufige Fragen",
      whatOverline: "Was wir tun",
      whyTitle: "Warum Sie uns wählen sollten",
      ctaOverline: "Sprechen wir darüber",
      ctaTitle: "Erzählen Sie uns von Ihrem Projekt",
      ctaText: "Eine kostenlose Beratung, um gemeinsam herauszufinden, wie wir Ihr Unternehmen automatisieren und wachsen lassen.",
      ctaPrimary: "Kostenlose Beratung buchen",
      ctaSecondary: "Mit dem KI-Assistenten sprechen",
      services: {
        gestionale: {
          chip: "Software",
          title: "Maßgeschneiderte Verwaltungssoftware",
          subtitle: "Wir passen Ihr Unternehmen nicht an eine Software an: Wir bauen die Software um Ihr Unternehmen herum. ERP, CRM und operative Plattformen, zugeschnitten auf Ihre Prozesse.",
          metaTitle: "Maßgeschneiderte Verwaltungssoftware — XS Consulting",
          features: [
            { title: "Prozessanalyse", desc: "Wir erfassen Ihre echten Arbeitsabläufe, bevor eine Zeile Code geschrieben wird." },
            { title: "ERP & CRM nach Maß", desc: "Kunden, Bestellungen, Lager und Fakturierung in einem einzigen, für Sie gebauten Tool." },
            { title: "Operative Automatisierung", desc: "Wir beseitigen wiederkehrende Aufgaben mit automatisierten Abläufen und KI-Agenten." },
            { title: "Management-Dashboard", desc: "Verkäufe, Lager und Performance in Echtzeit, immer unter Kontrolle." },
            { title: "Integrationen", desc: "Wir verbinden die Software mit den Tools, die Sie bereits nutzen: E-Commerce, Buchhaltung, E-Mail." },
            { title: "Schulung & Support", desc: "Wir begleiten Ihr Team nach dem Go-live mit fortlaufender Unterstützung." },
          ],
          why: "Jede Software wird auf Ihre Prozesse zugeschnitten und wächst mit Ihrem Unternehmen: keine unnötigen Lizenzen, keine Funktionen, die Sie nie nutzen. Und mit unseren integrierten KI-Agenten arbeitet die Software für Sie, auch wenn Sie offline sind.",
          perChi: "Für Inhaber und Manager von KMU in der Schweiz und im Tessin, die jede Woche Stunden zwischen Excel-Tabellen, verstreuten Bestellungen und manueller Fakturierung verlieren — und ein einziges Werkzeug wollen, das auf ihre Prozesse zugeschnitten ist, nicht umgekehrt.",
          examples: [
            "Eine Werkstatt im Raum Lugano, die Aufträge, Stunden und Rechnungen in einem einzigen Dashboard verwaltet",
            "Ein Tessiner E-Commerce, der Lager und Bestellungen zwischen Shop und Verwaltungssoftware synchronisiert",
            "Eine Dienstleistungsfirma, die Angebote und Zahlungserinnerungen automatisiert",
          ],
          faq: [
            { q: "Was kostet eine maßgeschneiderte Verwaltungssoftware?", a: "Das hängt von Modulen und Integrationen ab. Nach der kostenlosen Beratung erhalten Sie ein fixes Angebot, ohne Überraschungen." },
            { q: "Wie lange dauert es?", a: "Eine erste einsatzbereite Version in der Regel in 4–8 Wochen, danach Erweiterung Modul für Modul." },
            { q: "Kann ich Daten aus meinem alten System importieren?", a: "Ja, wir migrieren Daten aus Excel, CSV und den gängigen Verwaltungssystemen in der Schweiz." },
            { q: "Unterstützt es die Schweizer Fakturierung (QR-Rechnung)?", a: "Ja, wir unterstützen QR-Rechnungen und Schweizer Fakturierungsstandards." },
            { q: "Was, wenn sich mein Prozess ändert?", a: "Die Software ist modular: Sie passt sich an und wächst mit Ihrem Unternehmen, mit fortlaufender Unterstützung durch unser Team im Tessin." },
          ],
        },
        impianti: {
          chip: "Ingenieurwesen",
          title: "Anlagenplanung",
          subtitle: "Echte Profis der Anlagenplanung: von der Aufnahme über die Dimensionierung bis zur technischen Ausführungsdokumentation.",
          metaTitle: "Anlagenplanung — XS Consulting",
          features: [
            { title: "Aufnahme & Analyse", desc: "Vor-Ort-Termin und Erfassung der technischen, funktionalen und gesetzlichen Anforderungen." },
            { title: "Dimensionierung", desc: "Berechnungen und Planungsentscheidungen nach den geltenden Normen." },
            { title: "Ausführungsschemata", desc: "Klare Pläne, bereit für die Umsetzung." },
            { title: "Technische Dokumentation", desc: "Berichte, Leistungsverzeichnisse und vollständige Unterlagen, immer in Ordnung." },
            { title: "Digitale Koordination", desc: "Aufträge, Revisionen und Lieferungen in einem einzigen digitalen Ablauf." },
            { title: "Baustellen-Support", desc: "Unterstützung während der Umsetzung und der Endabnahme." },
          ],
          why: "Wir verbinden die Erfahrung von Planungsprofis mit der Geschwindigkeit digitaler Werkzeuge: sichere Termine, immer geordnete Unterlagen und ein einziger Ansprechpartner für das gesamte Projekt.",
          perChi: "Für Bauunternehmen, Installateure und Ingenieurbüros im Tessin und in der Schweiz, die normgerechte Projekte, geordnete Dokumentation und verlässliche Termine brauchen.",
          examples: [
            "Elektroanlagen-Planung für eine neue Residenz in Manno",
            "Dimensionierung und Ausführungsschemata für die Sanierung eines Geschäftsgebäudes in Lugano",
            "Technische Dokumentation und digitale Koordination für ein Multi-Anlagen-Projekt",
          ],
          faq: [
            { q: "Arbeiten Sie in der ganzen Schweiz?", a: "Wir sind im Tessin und in der gesamten Schweiz tätig, mit Vor-Ort-Terminen nach Vereinbarung." },
            { q: "Kennen Sie die Schweizer Normen (NIN, SIA)?", a: "Ja, unsere Projekte folgen den in der Schweiz geltenden Normen und die Dokumentation ist vollständig für die zuständigen Behörden." },
            { q: "Können Sie von einer bestehenden Aufnahme ausgehen?", a: "Ja: Wir können eine bestehende Aufnahme prüfen oder eine neue vor Ort erstellen." },
            { q: "Wie lange dauert eine Planung?", a: "Das hängt vom Umfang ab: Nach einer ersten Analyse erhalten Sie einen klaren, verbindlichen Zeitplan." },
            { q: "Übernehmen Sie auch die Bauleitung?", a: "Auf Wunsch begleiten wir die Umsetzung und die Endabnahme." },
          ],
        },
        marketplace: {
          chip: "E-Commerce",
          title: "Automatisierung für Marketplace-Verkäufer",
          subtitle: "Sie verkaufen auf Amazon, eBay oder Zalando? Wir automatisieren die wiederkehrenden Aufgaben, damit Sie sich auf das Wachstum konzentrieren.",
          metaTitle: "Marketplace-Automatisierung — XS Consulting",
          features: [
            { title: "Katalogverwaltung", desc: "Produkte, Preise und Beschreibungen gleichzeitig auf mehreren Marktplätzen hochladen und aktualisieren." },
            { title: "Lagersynchronisation", desc: "Bestände in Echtzeit abgeglichen: keine Verkäufe ausverkaufter Produkte mehr." },
            { title: "Bestellungen & Versand", desc: "Automatischer Ablauf von der Bestellung bis zum Versandetikett." },
            { title: "Intelligentes Repricing", desc: "Preise werden nach Ihren Regeln an den Wettbewerb angepasst." },
            { title: "KI-Kundensupport", desc: "Automatische Antworten auf häufige Fragen und Käufernachrichten." },
            { title: "Reports & Analysen", desc: "Verkäufe, Margen und Performance in einem einzigen Dashboard." },
          ],
          why: "Wir verbinden die Marktplätze mit Ihrer Verwaltungssoftware und Ihren Tools – mit KI-Agenten, maßgeschneidert für Ihr Geschäft.",
          perChi: "Für Verkäufer und Marken in der Schweiz und Italien, die auf Amazon, eBay oder Zalando verkaufen und zu viele Stunden mit Katalogen, Preisen und Versand verbringen.",
          examples: [
            "Ein Tessiner Händler, der die Bestandsfehler zwischen Amazon und seiner Verwaltungssoftware um 90 % reduziert hat",
            "Eine Marke, die 2'000 Preise pro Tag mit automatischen Repricing-Regeln aktualisiert",
            "Ein E-Commerce, der Kunden in 3 Sprachen mit einem KI-Agenten beantwortet",
          ],
          faq: [
            { q: "Mit welchen Marktplätzen arbeiten Sie?", a: "Amazon, eBay, Zalando und weitere auf Anfrage, alle verbunden mit Ihrer Verwaltungssoftware." },
            { q: "Muss ich meine Verwaltungssoftware wechseln?", a: "Nein: Wir verbinden uns mit dem, was Sie bereits nutzen. Fehlt etwas, bauen wir die Brücke." },
            { q: "Kann das Repricing unter meine Marge fallen?", a: "Nein: Sie definieren die Regeln, mit Mindest- und Höchstpreisen, die nicht überschritten werden." },
            { q: "Wie schnell ist es aktiv?", a: "Die ersten Synchronisationen sind in der Regel innerhalb von 2–4 Wochen live." },
            { q: "Kann ich mit nur einem Marktplatz starten?", a: "Ja, danach fügen wir die anderen einzeln hinzu und messen die Ergebnisse." },
          ],
        },
      },
    },
  },
};
